module.exports = `<!DOCTYPE html>
<html>
    <head>
        <meta charset="UTF8">
        <meta name="viewport" content="width=device-width, initial-scale=1">
        <title>CASCADE - Workscope Wireframe</title>
        <style>
            * {
                box-sizing: border-box;
            }

            body {
                font-family: Helvetica, sans-serif;
            }

            a:link {
                text-decoration: none;
                color: #FFFFFF;
            }

            a:visited {
                text-decoration: none;
                color: #FFFFFF;
            }

            a:hover {
                text-decoration: underline;
                color: #FFFFFF;
            }

            a:active {
                text-decoration: underline;
                color: #FFFFFF;
            }

            [class*="col-"] {
                width: 100%;
                float: left;
                padding: 15px;
                border: 0;
            }

            @media only screen and (min-width: 600px) {
            /* For tablets: */
                .col-s-1 {width: 8.33%;}
                .col-s-2 {width: 16.66%;}
                .col-s-3 {width: 25%;}
                .col-s-4 {width: 33.33%;}
                .col-s-5 {width: 41.66%;}
                .col-s-6 {width: 50%;}
                .col-s-7 {width: 58.33%;}
                .col-s-8 {width: 66.66%;}
                .col-s-9 {width: 75%;}
                .col-s-10 {width: 83.33%;}
                .col-s-11 {width: 91.66%;}
                .col-s-12 {width: 100%;}
            }

            @media only screen and (min-width: 768px) {
            /* For desktop: */
                .col-1 {width: 8.33%;}
                .col-2 {width: 16.66%;}
                .col-3 {width: 25%;}
                .col-4 {width: 33.33%;}
                .col-5 {width: 41.66%;}
                .col-6 {width: 50%;}
                .col-7 {width: 58.33%;}
                .col-8 {width: 66.66%;}
                .col-9 {width: 75%;}
                .col-10 {width: 83.33%;}
                .col-11 {width: 91.66%;}
                .col-12 {width: 100%;}
            }

            .row::after {
                content: "";
                clear: both;
                display: table;
            }

            /* background-color: #607d8b; */
            .header, .footer {
                color: #FFFFFF;
                background-color: #000000;
                width: 100%;
                display: inline-block;
                padding-left: 10px;
                text-align: left;
            }

            h1 {
                font-size: 35px;
            }

            .results1 {
                margin: 40px;
            }

            .results2 {
                margin: 40px;
            }

            .hdrtext {
                display: inline-block;
            }

            .chart_title {
                font-family:helvetica;
                font-size:x-small;
            }

            .menubar1 {
                background-color: #505050;
            }

            .menubar2 {
                background-color: #606060;
            }

            .menubar3 {
                background-color: #707070;
            }

            .menubar4 {
                background-color: #808080;
            }

            .menubar5 {
                background-color: #909090;
            }

            .menubar6 {
                background-color: #0000B7;
            }

            .menuitem {
                display: block;
                color: #FFFFFF;
            }

            .mugshots {
                width: 100%;
            }

            .card-4,.hover-shadow:hover{
                box-shadow:0 4px 10px 0 rgba(0,0,0,0.2),0 4px 20px 0 rgba(0,0,0,0.19)
                border:0;
            }

            .vcard {
                padding-left: 10px;
                padding-right: 10px;
            }

            .rounded{
                border-radius: 10px;
                border: 2px solid black;
                width: 100%;
                margin: 5px;
            }

            .card-header {
                background-color: #f1f1f1;
                width: 100%;
                display: inline-block;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                padding-left: 10px;
                text-align: left;
            }

            .title {
                font-family: Helvetica;
                font-size: 11pt;
            }

            .bio {
                font-family: Helvetica;
                font-size: 9pt;
            }

            .c4-button {
                display:inline-block;
                width:100%;
                color: #FFFFFF;
                border: 2px solid #616161;
                background-color:#616161;
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
            }

            .modal {
                display: none; /* Hidden by default */
                position: fixed; /* Stay in place */
                z-index: 1; /* Sit on top */
                left: 0;
                top: 0;
                width: 100%; /* Full width */
                height: 100%; /* Full height */
                overflow: auto; /* Enable scroll if needed */
                background-color: rgb(0,0,0); /* Fallback color */
                background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
            }

            .modal-content {
                max-height: calc(100vh - 210px);
                overflow-y: auto;
                background-color: #fefefe;
                margin: 15% auto; /* 15% from the top and centered */
                padding: 20px;
                border: 4px solid #888;
                width: 80%; /* Could be more or less, depending on screen size */
            }

            .close {
                color: #aaa;
                float: right;
                font-size: 28px;
                font-weight: bold;
            }

            .close:hover,
            .close:focus {
            color: black;
            text-decoration: none;
            cursor: pointer;
            }

        </style>
    </head>
    <body onload="display_progress()">

        <div class="header">
            <img src="images/Trojan_Logo.png" alt="Trojan Energy Limited" class="w3-left" width="250px" style="padding:20px;">
            <div class="hdrtext" style="padding:20px;">
                <h1>CASCADE</h1>
                <h2>Cloud Architecture Systems Control and Data Engineering</h2>
            </div>
        </div>

        <div class="menubar1 row" style="width:100%;" id="menubar1">
            <div id="menu1Label" class="col-2 col-s-2 menuitem">Data Model Tools :</div>
            <div id="docButton" class="col-1 col-s-1 menuitem" data-my-custom-key="docgenButtonModal"><a href="#docgen" class="w3-button">Documents</a></div>
            <div id="modButton" class="col-1 col-s-1 menuitem" data-my-custom-key="modgenButtonModal"><a href="#modgen" class="w3-button">Models</a></div>
            <div id="modButton" class="col-1 col-s-1 menuitem" data-my-custom-key="modgenButtonModal"><a href="#hurtlocker" class="w3-button">Hurt Locker</a></div>
        </div>

        <div class="menubar2 row" style="width:100%;" id="menubar2">
            <div id="menu2Label" class="col-2 col-s-2 menuitem">Trojan Cloud Services :</div>
            <div id="csmsButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">CSMS</a></div>
            <div id="csmsButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Portal</a></div>
            <div id="matrixButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">MATRIX</a></div>
            <div id="orionButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">ORION</a></div>
            <div id="meshButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">MESH</a></div>
            <div id="prismButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">PRISM</a></div>
        </div>

        <div class="menubar3 row" style="width:100%;" id="menubar3">
            <div id="menu3Label" class="col-2 col-s-2 menuitem">Hardware Development :</div>
            <div id="cartButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Cartridge</a></div>
            <div id="lceButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Lance</a></div>
            <div id="axonButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">AXON</a></div>
            <div id="isoButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">ISO 15118</a></div>
            <div id="spsButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Spartan</a></div>
            <div id="penButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">PEN Fault</a></div>
            <div id="meterButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Metering</a></div>
        </div>

        <div class="menubar4 row" style="width:100%;" id="menubar4">
            <div id="menu4Label" class="col-2 col-s-2 menuitem">Systems / Control :</div>
            <div id="hydraButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Hydra</a></div>
            <div id="aonButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">AON</a></div>
            <div id="eonButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">EON</a></div>
            <div id="compButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Compliance</a></div>
            <div id="emcButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">EMC</a></div>
            <div id="v2hButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">V2H</a></div>
            <div id="impButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Imperius</a></div>
            <div id="ateButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">ATE</a></div>
        </div>

        <div class="menubar5 row" style="width:100%;" id="menubar5">
            <div id="menu5Label" class="col-2 col-s-2 menuitem">Business Tools :</div>
            <div id="dmButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Doc Control</a></div>
            <div id="timeButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Timesheets</a></div>
            <div id="ringButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Ringfence</a></div>
            <div id="flowButton" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">Workflow Engine</a></div>
            <div id="sha1Button" class="col-1 col-s-1 menuitem"><a href="#" class="w3-button">SHA1 Tasklist</a></div>
        </div>

        <div class="menubar6 row" style="width:100%;" id="menubar6">
            <div id="teamButton" class="col-1 col-s-1 menuitem"><a href="#Team" class="w3-button">Team</a></div>
        </div>

    <!-- Document Numbering Dialogue -->
    <div id="docgen" class="row">

        <!-- Modal content -->
        <div class="docgencontent">
            <span class="close">&times;</span>
            <p><b>Document Number Generator</b></p>
            <form>
                <div class="col-2 col-s-2">
                <label for="projects">Project</label><br />
                <select id="projects">
                    <!-- Query DB -->
                    <optgroup label="Projects">
                        <option value="NNNN">Select ...</option>
                        <option value="0001">STEP</option>
                        <option value="0002">SmartSTEP</option>
                        <option value="0003">DoorSTEP</option>
                    </optgroup>
                </select>
                </div>
                <div class="col-2 col-s-2">
                <label for="component">Component</label>
                <select id="component">
                    <!-- Query DB -->
                    <optgroup label="Components">
                        <option value="XXX">Select ...</option>
                        <option value="HYD">Hydra</option>
                        <option value="BAS">Base Unit</option>
                        <option value="CAR">Cartridge</option>
                        <option value="LCE">Lance</option>
                        <option value="TCS">Trojan Cloud Services</option>
                        <option value="APP">Application / Portal</option>
                        <option value="TEL">Trojan Energy Limited</option>
                        <option value="SYS">System</option>
                        <option value="PHX">Phalanx</option>
                        <option value="AON">AON</option>
                        <option value="EON">EON</option>
                        <option value="AXN">AXN</option>
                        <option value="SPS">Spartan</option>
                    </optgroup>
                </select>
                </div>
                <div class="col-3 col-s-3">
                <label for="sdrlcategory">SDRL Category</label>
                <select id="sdrlcategory">
                    <!-- Query DB -->
                    <optgroup label="SDRL Categories">
                        <option value="XNN">Select ...</option>
                        <option value="A00">Project Management</option>
                        <option value="B00">General Arrangements / Maps</option>
                        <option value="C00">Datasheets</option>
                        <option value="D00">Detail Drawings</option>
                        <option value="E00">Schematics / PCA Layouts</option>
                        <option value="F00">Design Information / Calculations</option>
                        <option value="H00">Procedures / Specifications</option>
                        <option value="J00">Operations</option>
                        <option value="K00">Certification</option>
                        <option value="L00">Results / Records / Reports</option>
                        <option value="M00">Logistics</option>
                        <option value="S00">Safety Documents</option>
                        <option value="U00">Software / Backend Systems</option>
                    </optgroup>
                </select>
                </div>
                <div class="col-5 col-s-5">
                <label for="sdrlsubcategory">SDRL Subcategory</label><br />
                <select id="sdrlsubcategory">
                    <!-- Query DB -->
                    <optgroup label="SDRL Sub-categories">
                        <option value="XXX">Select ...</option>
                        <option value="A00">Project Management</option>
                        <option value="B00">General Arrangements / Maps</option>
                        <option value="C00">Datasheets</option>
                        <option value="D00">Detail Drawings</option>
                        <option value="E00">Schematics / PCA Layouts</option>
                        <option value="F00">Design Information / Calculations</option>
                        <option value="H00">Procedures / Specifications</option>
                        <option value="J00">Operations</option>
                        <option value="K00">Certification</option>
                        <option value="L00">Results / Records / Reports</option>
                        <option value="M00">Logistics</option>
                        <option value="S00">Safety Documents</option>
                        <option value="U00">Software / Backend Systems</option>
                    </optgroup>
                </select>
                </div>
                <br />
                <div class="col-6 col-s-6">
                    <h2 id="documentID">Generated Document Number : </h2>
                </div>
                <div class="col-6 col-s-6">
                    <h1 id="documentID"><span id="docProjID">NNNN</span> - <span id="docCompID">XXX</span> - <span id="docSDRLID">XNN</span> - <span id="docIndexID">NNNNNN</span></h1>
                </div>
                <br />
                <input type="reset">
                <input type="submit" value="Submit">
                <br />
                <br />
                <hr />
            </form>
        </div>

    </div>

    <!-- Model Numbering Dialogue -->
    <div id="modgen" class="row">

        <!-- Modal content -->
        <div class="modgencontent">
            <span class="close">&times;</span>
            <p><b>Model Number Generator</b></p>
            <form>
                <div class="col-2 col-s-2">
                <label for="classes">Class</label><br />
                <select id="classes">
                    <!-- Query DB -->
                    <optgroup label="Classes">
                        <option value="XX">Select ...</option>
                        <option value="10">Hydra</option>
                        <option value="20">Cartridge</option>
                        <option value="25">Base Unit</option>
                        <option value="30">Lance</option>
                        <option value="40">AON</option>
                        <option value="50">EON</option>
                        <option value="60">AXON</option>
                        <option value="70">Spartan</option>
                        <option value="80">Software / Firmware</option>
                    </optgroup>
                </select>
                </div>
                <div class="col-2 col-s-2">
                <label for="subclasses">Subclass</label>
                <select id="subclasses">
                    <!-- Query DB -->
                    <optgroup label="Subclasses">
                        <option value="XX">Select ...</option>
                        <option value="01">Hydra</option>
                        <option value="02">Base Unit</option>
                        <option value="04">Cartridge</option>
                        <option value="08">Lance</option>
                        <option value="16">Trojan Cloud Services</option>
                        <option value="32">Application / Portal</option>
                        <option value="">Trojan Energy Limited</option>
                        <option value="">System</option>
                        <option value="">Phalanx</option>
                        <option value="">AON</option>
                        <option value="">EON</option>
                        <option value="">AXN</option>
                        <option value="">Spartan</option>
                    </optgroup>
                </select>
                </div>
                <div class="col-3 col-s-3">
                <label for="component_classes">Component Classes</label>
                <select id="component_classes">
                    <!-- Query DB -->
                    <optgroup label="Component Classes">
                        <option value="NNN">Select ...</option>
                        <option value="000">Top Level</option>
                        <option value="001">Functional Switching</option>
                        <option value="002">Electric Shock Protection</option>
                        <option value="004">Short Circuit Protection</option>
                        <option value="008">Protective Earth Monitoring</option>
                        <option value="016">Metering</option>
                        <option value="032">Termination</option>
                        <option value="064">Foundation</option>
                        <option value="065">Enclosure</option>
                        <option value="066">Locking</option>
                        <option value="067">Ventilation</option>
                        <option value="068">Backboard / Frame</option>
                        <option value="069">Fixings</option>
                        <option value="070">Seals</option>
                        <option value="071">Markings / Plates</option>
                        <option value="072">Logic Solver</option>
                        <option value="073">IO Interface</option>
                        <option value="074">DC Power Supply</option>
                        <option value="075">Modem</option>
                        <option value="076">Antenna</option>
                        <option value="077">Isolation, Safety</option>
                        <option value="078">Isolation, Functional</option>
                        <option value="079">Protocol Converter</option>
                        <option value="080">Cabling Assembly</option>
                    </optgroup>
                </select>
                </div>
                <div class="col-5 col-s-5">
                <label for="index">Index</label><br />
                <select id="index">
                    <!-- Query DB -->
                    <optgroup label="SDRL Sub-categories">
                        <option value="XXX">Select ...</option>
                        <option value="A00">Project Management</option>
                        <option value="B00">General Arrangements / Maps</option>
                        <option value="C00">Datasheets</option>
                        <option value="D00">Detail Drawings</option>
                        <option value="E00">Schematics / PCA Layouts</option>
                        <option value="F00">Design Information / Calculations</option>
                        <option value="H00">Procedures / Specifications</option>
                        <option value="J00">Operations</option>
                        <option value="K00">Certification</option>
                        <option value="L00">Results / Records / Reports</option>
                        <option value="M00">Logistics</option>
                        <option value="S00">Safety Documents</option>
                        <option value="U00">Software / Backend Systems</option>
                    </optgroup>
                </select>
                </div>
                <br />
                <div class="col-6 col-s-6">
                    <h2 id="documentID">Generated Model Number : </h2>
                </div>
                <div class="col-6 col-s-6">
                    <h1 id="documentID"><span id="modClassID">NN</span><span id="modSubClassID">NN</span><span id="modFunctionID">NNN</span><span id="docIndexID">NNNNN</span></h1>
                </div>
                <br />
                <input type="reset">
                <input type="submit" value="Submit">
                <br />
                <br />
                <hr />
            </form>
        </div>

    </div>

    <div class="row" id="hurtlocker">
        <h1>Hurt Locker</h1>

        <div class="results1">
        <!-- ID Definitions             -->
        <!-- datasheets_grid            : Does a datasheet exist in the system for this part? -->
        <!-- part_numbers_grid          : Is the part number recognised in the system? -->
        <!-- manufacturers_grid         : Is the manufacturer recognised in the system for this part? -->
        <!-- reach_compliance_grid      : Is there REACH documentation available in the system for this part? -->
        <!-- rohs_compliance_grid       : Is there RoHS documentation available in the system for this part? -->
        <!-- stock_availability_grid    : Is there stock held for this part? >Reqd Qty | <Reqd Qty | None -->
        <!-- vendor_availability_grid   : Is there vendor stock for this part? >Reqd Qty | <Reqd Qty | None -->
        <!-- delivery_grid              : Is there stock ordered for this part? Due before reqd date | Due after reqd date | No order -->
        <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100mm"
        height="100mm"
        viewBox="0 0 100 162"
        version="1.1"
        id="datasheets_grid">
        <defs
            id="defs2" />
        <metadata
            id="metadata5">
            <rdf:RDF>
            <cc:Work
                rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type
                rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                <dc:title></dc:title>
            </cc:Work>
            </rdf:RDF>
        </metadata>
            <g id="Progress">
                <text id="ChartTitle" class="chart_title" x="0" y="8" class="small">Chart Title</text>
                <rect id="GRID00" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,10)" />
                <rect id="GRID01" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,10)" />
                <rect id="GRID02" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,10)" />
                <rect id="GRID03" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,10)" />
                <rect id="GRID04" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,10)" />
                <rect id="GRID05" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,10)" />
                <rect id="GRID06" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,10)" />
                <rect id="GRID07" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,10)" />
                <rect id="GRID08" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,10)" />
                <rect id="GRID09" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,10)" />
                <rect id="GRID10" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,20)" />
                <rect id="GRID11" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,20)" />
                <rect id="GRID12" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,20)" />
                <rect id="GRID13" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,20)" />
                <rect id="GRID14" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,20)" />
                <rect id="GRID15" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,20)" />
                <rect id="GRID16" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,20)" />
                <rect id="GRID17" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,20)" />
                <rect id="GRID18" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,20)" />
                <rect id="GRID19" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,20)" />
                <rect id="GRID20" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,30)" />
                <rect id="GRID21" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,30)" />
                <rect id="GRID22" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,30)" />
                <rect id="GRID23" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,30)" />
                <rect id="GRID24" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,30)" />
                <rect id="GRID25" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,30)" />
                <rect id="GRID26" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,30)" />
                <rect id="GRID27" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,30)" />
                <rect id="GRID28" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,30)" />
                <rect id="GRID29" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,30)" />
                <rect id="GRID30" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,40)" />
                <rect id="GRID31" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,40)" />
                <rect id="GRID32" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,40)" />
                <rect id="GRID33" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,40)" />
                <rect id="GRID34" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,40)" />
                <rect id="GRID35" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,40)" />
                <rect id="GRID36" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,40)" />
                <rect id="GRID37" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,40)" />
                <rect id="GRID38" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,40)" />
                <rect id="GRID39" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,40)" />
                <rect id="GRID40" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,50)" />
                <rect id="GRID41" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,50)" />
                <rect id="GRID42" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,50)" />
                <rect id="GRID43" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,50)" />
                <rect id="GRID44" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,50)" />
                <rect id="GRID45" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,50)" />
                <rect id="GRID46" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,50)" />
                <rect id="GRID47" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,50)" />
                <rect id="GRID48" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,50)" />
                <rect id="GRID49" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,50)" />
                <rect id="GRID50" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,60)" />
                <rect id="GRID51" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,60)" />
                <rect id="GRID52" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,60)" />
                <rect id="GRID53" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,60)" />
                <rect id="GRID54" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,60)" />
                <rect id="GRID55" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,60)" />
                <rect id="GRID56" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,60)" />
                <rect id="GRID57" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,60)" />
                <rect id="GRID58" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,60)" />
                <rect id="GRID59" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,60)" />
                <rect id="GRID60" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,70)" />
                <rect id="GRID61" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,70)" />
                <rect id="GRID62" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,70)" />
                <rect id="GRID63" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,70)" />
                <rect id="GRID64" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,70)" />
                <rect id="GRID65" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,70)" />
                <rect id="GRID66" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,70)" />
                <rect id="GRID67" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,70)" />
                <rect id="GRID68" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,70)" />
                <rect id="GRID69" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,70)" />
                <rect id="GRID70" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,80)" />
                <rect id="GRID71" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,80)" />
                <rect id="GRID72" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,80)" />
                <rect id="GRID73" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,80)" />
                <rect id="GRID74" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,80)" />
                <rect id="GRID75" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,80)" />
                <rect id="GRID76" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,80)" />
                <rect id="GRID77" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,80)" />
                <rect id="GRID78" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,80)" />
                <rect id="GRID79" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,80)" />
                <rect id="GRID80" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,90)" />
                <rect id="GRID81" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,90)" />
                <rect id="GRID82" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,90)" />
                <rect id="GRID83" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,90)" />
                <rect id="GRID84" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,90)" />
                <rect id="GRID85" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,90)" />
                <rect id="GRID86" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,90)" />
                <rect id="GRID87" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,90)" />
                <rect id="GRID88" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,90)" />
                <rect id="GRID89" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,90)" />
                <rect id="GRID90" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,100)" />
                <rect id="GRID91" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,100)" />
                <rect id="GRID92" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,100)" />
                <rect id="GRID93" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,100)" />
                <rect id="GRID94" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,100)" />
                <rect id="GRID95" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,100)" />
                <rect id="GRID96" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,100)" />
                <rect id="GRID97" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,100)" />
                <rect id="GRID98" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,100)" />
                <rect id="GRID99" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,100)" />
                <rect id="KEYGOOD" class="KeyUnit" width="10" height="10" style="fill:rgb(0,198,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,120)" />
                <rect id="KEYMEH" class="KeyUnit" width="10" height="10" style="fill:rgb(198,165,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,130)" />
                <rect id="KEYBAD" class="KeyUnit" width="10" height="10" style="fill:rgb(198,0,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,140)" />
                <rect id="KEYNONE" class="KeyUnit" width="10" height="10" style="fill:rgb(198,198,198);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,150)" />
                <text id="GoodKeyText" x="20" y="128" class="small" style="font-family:helvetica;font-size:xx-small;">GOOD Text</text>
                <text id="MehKeyText" x="20" y="138" class="small" style="font-family:helvetica;font-size:xx-small;">MEH Text</text>
                <text id="BadKeyText" x="20" y="148" class="small" style="font-family:helvetica;font-size:xx-small;">BAD Text</text>
                <text id="NoneKeyText" x="20" y="158" class="small" style="font-family:helvetica;font-size:xx-small;">UNDEFINED Text</text>
            </g>
        </svg>

        <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100mm"
        height="100mm"
        viewBox="0 0 100 162"
        version="1.1"
        id="part_numbers_grid">
        <defs
            id="defs2" />
        <metadata
            id="metadata5">
            <rdf:RDF>
            <cc:Work
                rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type
                rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                <dc:title></dc:title>
            </cc:Work>
            </rdf:RDF>
        </metadata>
            <g id="Progress">
                <text id="ChartTitle" x="0" y="8" class="small" style="font-family:helvetica;font-size:x-small" zIndex=999999>Chart Title</text>
                <rect id="GRID00" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,10)" />
                <rect id="GRID01" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,10)" />
                <rect id="GRID02" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,10)" />
                <rect id="GRID03" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,10)" />
                <rect id="GRID04" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,10)" />
                <rect id="GRID05" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,10)" />
                <rect id="GRID06" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,10)" />
                <rect id="GRID07" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,10)" />
                <rect id="GRID08" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,10)" />
                <rect id="GRID09" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,10)" />
                <rect id="GRID10" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,20)" />
                <rect id="GRID11" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,20)" />
                <rect id="GRID12" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,20)" />
                <rect id="GRID13" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,20)" />
                <rect id="GRID14" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,20)" />
                <rect id="GRID15" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,20)" />
                <rect id="GRID16" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,20)" />
                <rect id="GRID17" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,20)" />
                <rect id="GRID18" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,20)" />
                <rect id="GRID19" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,20)" />
                <rect id="GRID20" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,30)" />
                <rect id="GRID21" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,30)" />
                <rect id="GRID22" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,30)" />
                <rect id="GRID23" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,30)" />
                <rect id="GRID24" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,30)" />
                <rect id="GRID25" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,30)" />
                <rect id="GRID26" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,30)" />
                <rect id="GRID27" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,30)" />
                <rect id="GRID28" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,30)" />
                <rect id="GRID29" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,30)" />
                <rect id="GRID30" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,40)" />
                <rect id="GRID31" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,40)" />
                <rect id="GRID32" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,40)" />
                <rect id="GRID33" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,40)" />
                <rect id="GRID34" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,40)" />
                <rect id="GRID35" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,40)" />
                <rect id="GRID36" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,40)" />
                <rect id="GRID37" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,40)" />
                <rect id="GRID38" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,40)" />
                <rect id="GRID39" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,40)" />
                <rect id="GRID40" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,50)" />
                <rect id="GRID41" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,50)" />
                <rect id="GRID42" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,50)" />
                <rect id="GRID43" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,50)" />
                <rect id="GRID44" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,50)" />
                <rect id="GRID45" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,50)" />
                <rect id="GRID46" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,50)" />
                <rect id="GRID47" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,50)" />
                <rect id="GRID48" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,50)" />
                <rect id="GRID49" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,50)" />
                <rect id="GRID50" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,60)" />
                <rect id="GRID51" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,60)" />
                <rect id="GRID52" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,60)" />
                <rect id="GRID53" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,60)" />
                <rect id="GRID54" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,60)" />
                <rect id="GRID55" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,60)" />
                <rect id="GRID56" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,60)" />
                <rect id="GRID57" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,60)" />
                <rect id="GRID58" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,60)" />
                <rect id="GRID59" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,60)" />
                <rect id="GRID60" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,70)" />
                <rect id="GRID61" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,70)" />
                <rect id="GRID62" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,70)" />
                <rect id="GRID63" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,70)" />
                <rect id="GRID64" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,70)" />
                <rect id="GRID65" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,70)" />
                <rect id="GRID66" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,70)" />
                <rect id="GRID67" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,70)" />
                <rect id="GRID68" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,70)" />
                <rect id="GRID69" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,70)" />
                <rect id="GRID70" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,80)" />
                <rect id="GRID71" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,80)" />
                <rect id="GRID72" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,80)" />
                <rect id="GRID73" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,80)" />
                <rect id="GRID74" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,80)" />
                <rect id="GRID75" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,80)" />
                <rect id="GRID76" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,80)" />
                <rect id="GRID77" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,80)" />
                <rect id="GRID78" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,80)" />
                <rect id="GRID79" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,80)" />
                <rect id="GRID80" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,90)" />
                <rect id="GRID81" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,90)" />
                <rect id="GRID82" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,90)" />
                <rect id="GRID83" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,90)" />
                <rect id="GRID84" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,90)" />
                <rect id="GRID85" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,90)" />
                <rect id="GRID86" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,90)" />
                <rect id="GRID87" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,90)" />
                <rect id="GRID88" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,90)" />
                <rect id="GRID89" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,90)" />
                <rect id="GRID90" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,100)" />
                <rect id="GRID91" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,100)" />
                <rect id="GRID92" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,100)" />
                <rect id="GRID93" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,100)" />
                <rect id="GRID94" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,100)" />
                <rect id="GRID95" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,100)" />
                <rect id="GRID96" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,100)" />
                <rect id="GRID97" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,100)" />
                <rect id="GRID98" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,100)" />
                <rect id="GRID99" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,100)" />
                <rect id="KEYGOOD" class="KeyUnit" width="10" height="10" style="fill:rgb(0,198,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,120)" />
                <rect id="KEYMEH" class="KeyUnit" width="10" height="10" style="fill:rgb(198,165,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,130)" />
                <rect id="KEYBAD" class="KeyUnit" width="10" height="10" style="fill:rgb(198,0,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,140)" />
                <rect id="KEYNONE" class="KeyUnit" width="10" height="10" style="fill:rgb(198,198,198);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,150)" />
                <text id="BadKeyText" x="20" y="148" class="small" style="font-family:helvetica;font-size:xx-small;">BAD Text</text>
                <text id="MehKeyText" x="20" y="138" class="small" style="font-family:helvetica;font-size:xx-small;">MEH Text</text>
                <text id="GoodKeyText" x="20" y="128" class="small" style="font-family:helvetica;font-size:xx-small;">GOOD Text</text>
                <text id="NoneKeyText" x="20" y="158" class="small" style="font-family:helvetica;font-size:xx-small;">UNDEFINED Text</text>
            </g>
        </svg>

        <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100mm"
        height="100mm"
        viewBox="0 0 100 162"
        version="1.1"
        id="manufacturers_grid">
        <defs
            id="defs2" />
        <metadata
            id="metadata5">
            <rdf:RDF>
            <cc:Work
                rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type
                rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                <dc:title></dc:title>
            </cc:Work>
            </rdf:RDF>
        </metadata>
            <g id="Progress">
                <text id="ChartTitle" x="0" y="8" class="small" style="font-family:helvetica;font-size:x-small" zIndex=999999>Chart Title</text>
                <rect id="GRID00" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,10)" />
                <rect id="GRID01" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,10)" />
                <rect id="GRID02" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,10)" />
                <rect id="GRID03" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,10)" />
                <rect id="GRID04" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,10)" />
                <rect id="GRID05" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,10)" />
                <rect id="GRID06" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,10)" />
                <rect id="GRID07" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,10)" />
                <rect id="GRID08" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,10)" />
                <rect id="GRID09" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,10)" />
                <rect id="GRID10" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,20)" />
                <rect id="GRID11" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,20)" />
                <rect id="GRID12" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,20)" />
                <rect id="GRID13" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,20)" />
                <rect id="GRID14" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,20)" />
                <rect id="GRID15" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,20)" />
                <rect id="GRID16" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,20)" />
                <rect id="GRID17" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,20)" />
                <rect id="GRID18" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,20)" />
                <rect id="GRID19" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,20)" />
                <rect id="GRID20" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,30)" />
                <rect id="GRID21" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,30)" />
                <rect id="GRID22" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,30)" />
                <rect id="GRID23" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,30)" />
                <rect id="GRID24" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,30)" />
                <rect id="GRID25" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,30)" />
                <rect id="GRID26" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,30)" />
                <rect id="GRID27" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,30)" />
                <rect id="GRID28" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,30)" />
                <rect id="GRID29" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,30)" />
                <rect id="GRID30" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,40)" />
                <rect id="GRID31" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,40)" />
                <rect id="GRID32" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,40)" />
                <rect id="GRID33" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,40)" />
                <rect id="GRID34" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,40)" />
                <rect id="GRID35" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,40)" />
                <rect id="GRID36" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,40)" />
                <rect id="GRID37" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,40)" />
                <rect id="GRID38" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,40)" />
                <rect id="GRID39" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,40)" />
                <rect id="GRID40" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,50)" />
                <rect id="GRID41" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,50)" />
                <rect id="GRID42" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,50)" />
                <rect id="GRID43" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,50)" />
                <rect id="GRID44" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,50)" />
                <rect id="GRID45" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,50)" />
                <rect id="GRID46" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,50)" />
                <rect id="GRID47" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,50)" />
                <rect id="GRID48" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,50)" />
                <rect id="GRID49" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,50)" />
                <rect id="GRID50" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,60)" />
                <rect id="GRID51" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,60)" />
                <rect id="GRID52" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,60)" />
                <rect id="GRID53" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,60)" />
                <rect id="GRID54" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,60)" />
                <rect id="GRID55" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,60)" />
                <rect id="GRID56" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,60)" />
                <rect id="GRID57" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,60)" />
                <rect id="GRID58" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,60)" />
                <rect id="GRID59" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,60)" />
                <rect id="GRID60" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,70)" />
                <rect id="GRID61" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,70)" />
                <rect id="GRID62" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,70)" />
                <rect id="GRID63" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,70)" />
                <rect id="GRID64" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,70)" />
                <rect id="GRID65" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,70)" />
                <rect id="GRID66" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,70)" />
                <rect id="GRID67" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,70)" />
                <rect id="GRID68" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,70)" />
                <rect id="GRID69" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,70)" />
                <rect id="GRID70" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,80)" />
                <rect id="GRID71" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,80)" />
                <rect id="GRID72" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,80)" />
                <rect id="GRID73" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,80)" />
                <rect id="GRID74" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,80)" />
                <rect id="GRID75" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,80)" />
                <rect id="GRID76" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,80)" />
                <rect id="GRID77" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,80)" />
                <rect id="GRID78" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,80)" />
                <rect id="GRID79" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,80)" />
                <rect id="GRID80" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,90)" />
                <rect id="GRID81" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,90)" />
                <rect id="GRID82" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,90)" />
                <rect id="GRID83" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,90)" />
                <rect id="GRID84" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,90)" />
                <rect id="GRID85" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,90)" />
                <rect id="GRID86" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,90)" />
                <rect id="GRID87" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,90)" />
                <rect id="GRID88" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,90)" />
                <rect id="GRID89" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,90)" />
                <rect id="GRID90" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,100)" />
                <rect id="GRID91" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,100)" />
                <rect id="GRID92" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,100)" />
                <rect id="GRID93" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,100)" />
                <rect id="GRID94" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,100)" />
                <rect id="GRID95" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,100)" />
                <rect id="GRID96" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,100)" />
                <rect id="GRID97" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,100)" />
                <rect id="GRID98" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,100)" />
                <rect id="GRID99" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,100)" />
                <rect id="KEYGOOD" class="KeyUnit" width="10" height="10" style="fill:rgb(0,198,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,120)" />
                <rect id="KEYMEH" class="KeyUnit" width="10" height="10" style="fill:rgb(198,165,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,130)" />
                <rect id="KEYBAD" class="KeyUnit" width="10" height="10" style="fill:rgb(198,0,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,140)" />
                <rect id="KEYNONE" class="KeyUnit" width="10" height="10" style="fill:rgb(198,198,198);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,150)" />
                <text id="GoodKeyText" x="20" y="128" class="small" style="font-family:helvetica;font-size:xx-small;">GOOD Text</text>
                <text id="MehKeyText" x="20" y="138" class="small" style="font-family:helvetica;font-size:xx-small;">MEH Text</text>
                <text id="BadKeyText" x="20" y="148" class="small" style="font-family:helvetica;font-size:xx-small;">BAD Text</text>
                <text id="NoneKeyText" x="20" y="158" class="small" style="font-family:helvetica;font-size:xx-small;">UNDEFINED Text</text>
            </g>
        </svg>

        <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100mm"
        height="100mm"
        viewBox="0 0 100 162"
        version="1.1"
        id="reach_compliance_grid">
        <defs
            id="defs2" />
        <metadata
            id="metadata5">
            <rdf:RDF>
            <cc:Work
                rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type
                rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                <dc:title></dc:title>
            </cc:Work>
            </rdf:RDF>
        </metadata>
            <g id="Progress">
                <text id="ChartTitle" x="0" y="8" class="small" style="font-family:helvetica;font-size:x-small" zIndex=999999>Chart Title</text>
                <rect id="GRID00" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,10)" />
                <rect id="GRID01" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,10)" />
                <rect id="GRID02" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,10)" />
                <rect id="GRID03" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,10)" />
                <rect id="GRID04" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,10)" />
                <rect id="GRID05" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,10)" />
                <rect id="GRID06" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,10)" />
                <rect id="GRID07" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,10)" />
                <rect id="GRID08" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,10)" />
                <rect id="GRID09" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,10)" />
                <rect id="GRID10" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,20)" />
                <rect id="GRID11" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,20)" />
                <rect id="GRID12" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,20)" />
                <rect id="GRID13" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,20)" />
                <rect id="GRID14" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,20)" />
                <rect id="GRID15" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,20)" />
                <rect id="GRID16" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,20)" />
                <rect id="GRID17" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,20)" />
                <rect id="GRID18" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,20)" />
                <rect id="GRID19" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,20)" />
                <rect id="GRID20" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,30)" />
                <rect id="GRID21" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,30)" />
                <rect id="GRID22" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,30)" />
                <rect id="GRID23" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,30)" />
                <rect id="GRID24" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,30)" />
                <rect id="GRID25" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,30)" />
                <rect id="GRID26" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,30)" />
                <rect id="GRID27" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,30)" />
                <rect id="GRID28" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,30)" />
                <rect id="GRID29" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,30)" />
                <rect id="GRID30" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,40)" />
                <rect id="GRID31" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,40)" />
                <rect id="GRID32" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,40)" />
                <rect id="GRID33" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,40)" />
                <rect id="GRID34" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,40)" />
                <rect id="GRID35" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,40)" />
                <rect id="GRID36" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,40)" />
                <rect id="GRID37" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,40)" />
                <rect id="GRID38" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,40)" />
                <rect id="GRID39" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,40)" />
                <rect id="GRID40" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,50)" />
                <rect id="GRID41" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,50)" />
                <rect id="GRID42" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,50)" />
                <rect id="GRID43" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,50)" />
                <rect id="GRID44" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,50)" />
                <rect id="GRID45" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,50)" />
                <rect id="GRID46" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,50)" />
                <rect id="GRID47" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,50)" />
                <rect id="GRID48" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,50)" />
                <rect id="GRID49" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,50)" />
                <rect id="GRID50" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,60)" />
                <rect id="GRID51" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,60)" />
                <rect id="GRID52" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,60)" />
                <rect id="GRID53" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,60)" />
                <rect id="GRID54" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,60)" />
                <rect id="GRID55" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,60)" />
                <rect id="GRID56" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,60)" />
                <rect id="GRID57" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,60)" />
                <rect id="GRID58" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,60)" />
                <rect id="GRID59" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,60)" />
                <rect id="GRID60" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,70)" />
                <rect id="GRID61" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,70)" />
                <rect id="GRID62" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,70)" />
                <rect id="GRID63" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,70)" />
                <rect id="GRID64" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,70)" />
                <rect id="GRID65" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,70)" />
                <rect id="GRID66" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,70)" />
                <rect id="GRID67" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,70)" />
                <rect id="GRID68" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,70)" />
                <rect id="GRID69" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,70)" />
                <rect id="GRID70" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,80)" />
                <rect id="GRID71" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,80)" />
                <rect id="GRID72" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,80)" />
                <rect id="GRID73" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,80)" />
                <rect id="GRID74" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,80)" />
                <rect id="GRID75" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,80)" />
                <rect id="GRID76" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,80)" />
                <rect id="GRID77" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,80)" />
                <rect id="GRID78" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,80)" />
                <rect id="GRID79" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,80)" />
                <rect id="GRID80" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,90)" />
                <rect id="GRID81" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,90)" />
                <rect id="GRID82" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,90)" />
                <rect id="GRID83" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,90)" />
                <rect id="GRID84" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,90)" />
                <rect id="GRID85" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,90)" />
                <rect id="GRID86" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,90)" />
                <rect id="GRID87" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,90)" />
                <rect id="GRID88" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,90)" />
                <rect id="GRID89" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,90)" />
                <rect id="GRID90" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,100)" />
                <rect id="GRID91" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,100)" />
                <rect id="GRID92" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,100)" />
                <rect id="GRID93" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,100)" />
                <rect id="GRID94" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,100)" />
                <rect id="GRID95" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,100)" />
                <rect id="GRID96" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,100)" />
                <rect id="GRID97" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,100)" />
                <rect id="GRID98" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,100)" />
                <rect id="GRID99" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,100)" />
                <rect id="KEYGOOD" class="KeyUnit" width="10" height="10" style="fill:rgb(0,198,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,120)" />
                <text id="GoodKeyText" x="20" y="128" class="small" style="font-family:helvetica;font-size:xx-small;">GOOD Text</text>
                <rect id="KEYMEH" class="KeyUnit" width="10" height="10" style="fill:rgb(198,165,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,130)" />
                <text id="MehKeyText" x="20" y="138" class="small" style="font-family:helvetica;font-size:xx-small;">MEH Text</text>
                <rect id="KEYBAD" class="KeyUnit" width="10" height="10" style="fill:rgb(198,0,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,140)" />
                <text id="BadKeyText" x="20" y="148" class="small" style="font-family:helvetica;font-size:xx-small;">BAD Text</text>
                <rect id="KEYNONE" class="KeyUnit" width="10" height="10" style="fill:rgb(198,198,198);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,150)" />
                <text id="NoneKeyText" x="20" y="158" class="small" style="font-family:helvetica;font-size:xx-small;">UNDEFINED Text</text>
            </g>
        </svg>
        </div>
        <div class="results2">
        <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100mm"
        height="100mm"
        viewBox="0 0 100 162"
        version="1.1"
        id="rohs_compliance_grid">
        <defs
            id="defs2" />
        <metadata
            id="metadata5">
            <rdf:RDF>
            <cc:Work
                rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type
                rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                <dc:title></dc:title>
            </cc:Work>
            </rdf:RDF>
        </metadata>
            <g id="Progress">
                <text id="ChartTitle" x="0" y="8" class="small" style="font-family:helvetica;font-size:x-small" zIndex=999999>Chart Title</text>
                <rect id="GRID00" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,10)" />
                <rect id="GRID01" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,10)" />
                <rect id="GRID02" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,10)" />
                <rect id="GRID03" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,10)" />
                <rect id="GRID04" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,10)" />
                <rect id="GRID05" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,10)" />
                <rect id="GRID06" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,10)" />
                <rect id="GRID07" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,10)" />
                <rect id="GRID08" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,10)" />
                <rect id="GRID09" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,10)" />
                <rect id="GRID10" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,20)" />
                <rect id="GRID11" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,20)" />
                <rect id="GRID12" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,20)" />
                <rect id="GRID13" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,20)" />
                <rect id="GRID14" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,20)" />
                <rect id="GRID15" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,20)" />
                <rect id="GRID16" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,20)" />
                <rect id="GRID17" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,20)" />
                <rect id="GRID18" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,20)" />
                <rect id="GRID19" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,20)" />
                <rect id="GRID20" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,30)" />
                <rect id="GRID21" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,30)" />
                <rect id="GRID22" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,30)" />
                <rect id="GRID23" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,30)" />
                <rect id="GRID24" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,30)" />
                <rect id="GRID25" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,30)" />
                <rect id="GRID26" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,30)" />
                <rect id="GRID27" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,30)" />
                <rect id="GRID28" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,30)" />
                <rect id="GRID29" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,30)" />
                <rect id="GRID30" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,40)" />
                <rect id="GRID31" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,40)" />
                <rect id="GRID32" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,40)" />
                <rect id="GRID33" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,40)" />
                <rect id="GRID34" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,40)" />
                <rect id="GRID35" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,40)" />
                <rect id="GRID36" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,40)" />
                <rect id="GRID37" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,40)" />
                <rect id="GRID38" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,40)" />
                <rect id="GRID39" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,40)" />
                <rect id="GRID40" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,50)" />
                <rect id="GRID41" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,50)" />
                <rect id="GRID42" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,50)" />
                <rect id="GRID43" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,50)" />
                <rect id="GRID44" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,50)" />
                <rect id="GRID45" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,50)" />
                <rect id="GRID46" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,50)" />
                <rect id="GRID47" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,50)" />
                <rect id="GRID48" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,50)" />
                <rect id="GRID49" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,50)" />
                <rect id="GRID50" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,60)" />
                <rect id="GRID51" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,60)" />
                <rect id="GRID52" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,60)" />
                <rect id="GRID53" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,60)" />
                <rect id="GRID54" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,60)" />
                <rect id="GRID55" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,60)" />
                <rect id="GRID56" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,60)" />
                <rect id="GRID57" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,60)" />
                <rect id="GRID58" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,60)" />
                <rect id="GRID59" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,60)" />
                <rect id="GRID60" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,70)" />
                <rect id="GRID61" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,70)" />
                <rect id="GRID62" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,70)" />
                <rect id="GRID63" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,70)" />
                <rect id="GRID64" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,70)" />
                <rect id="GRID65" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,70)" />
                <rect id="GRID66" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,70)" />
                <rect id="GRID67" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,70)" />
                <rect id="GRID68" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,70)" />
                <rect id="GRID69" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,70)" />
                <rect id="GRID70" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,80)" />
                <rect id="GRID71" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,80)" />
                <rect id="GRID72" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,80)" />
                <rect id="GRID73" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,80)" />
                <rect id="GRID74" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,80)" />
                <rect id="GRID75" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,80)" />
                <rect id="GRID76" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,80)" />
                <rect id="GRID77" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,80)" />
                <rect id="GRID78" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,80)" />
                <rect id="GRID79" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,80)" />
                <rect id="GRID80" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,90)" />
                <rect id="GRID81" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,90)" />
                <rect id="GRID82" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,90)" />
                <rect id="GRID83" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,90)" />
                <rect id="GRID84" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,90)" />
                <rect id="GRID85" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,90)" />
                <rect id="GRID86" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,90)" />
                <rect id="GRID87" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,90)" />
                <rect id="GRID88" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,90)" />
                <rect id="GRID89" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,90)" />
                <rect id="GRID90" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,100)" />
                <rect id="GRID91" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,100)" />
                <rect id="GRID92" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,100)" />
                <rect id="GRID93" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,100)" />
                <rect id="GRID94" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,100)" />
                <rect id="GRID95" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,100)" />
                <rect id="GRID96" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,100)" />
                <rect id="GRID97" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,100)" />
                <rect id="GRID98" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,100)" />
                <rect id="GRID99" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,100)" />
                <rect id="KEYGOOD" class="KeyUnit" width="10" height="10" style="fill:rgb(0,198,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,120)" />
                <text id="GoodKeyText" x="20" y="128" class="small" style="font-family:helvetica;font-size:xx-small;">GOOD Text</text>
                <rect id="KEYMEH" class="KeyUnit" width="10" height="10" style="fill:rgb(198,165,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,130)" />
                <text id="MehKeyText" x="20" y="138" class="small" style="font-family:helvetica;font-size:xx-small;">MEH Text</text>
                <rect id="KEYBAD" class="KeyUnit" width="10" height="10" style="fill:rgb(198,0,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,140)" />
                <text id="BadKeyText" x="20" y="148" class="small" style="font-family:helvetica;font-size:xx-small;">BAD Text</text>
                <rect id="KEYNONE" class="KeyUnit" width="10" height="10" style="fill:rgb(198,198,198);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,150)" />
                <text id="NoneKeyText" x="20" y="158" class="small" style="font-family:helvetica;font-size:xx-small;">UNDEFINED Text</text>
            </g>
        </svg>

        <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100mm"
        height="100mm"
        viewBox="0 0 100 162"
        version="1.1"
        id="stock_availability_grid">
        <defs
            id="defs2" />
        <metadata
            id="metadata5">
            <rdf:RDF>
            <cc:Work
                rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type
                rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                <dc:title></dc:title>
            </cc:Work>
            </rdf:RDF>
        </metadata>
            <g id="Progress">
                <text id="ChartTitle" x="0" y="8" class="small" style="font-family:helvetica;font-size:x-small" zIndex=999999>Chart Title</text>
                <rect id="GRID00" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,10)" />
                <rect id="GRID01" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,10)" />
                <rect id="GRID02" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,10)" />
                <rect id="GRID03" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,10)" />
                <rect id="GRID04" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,10)" />
                <rect id="GRID05" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,10)" />
                <rect id="GRID06" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,10)" />
                <rect id="GRID07" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,10)" />
                <rect id="GRID08" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,10)" />
                <rect id="GRID09" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,10)" />
                <rect id="GRID10" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,20)" />
                <rect id="GRID11" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,20)" />
                <rect id="GRID12" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,20)" />
                <rect id="GRID13" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,20)" />
                <rect id="GRID14" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,20)" />
                <rect id="GRID15" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,20)" />
                <rect id="GRID16" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,20)" />
                <rect id="GRID17" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,20)" />
                <rect id="GRID18" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,20)" />
                <rect id="GRID19" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,20)" />
                <rect id="GRID20" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,30)" />
                <rect id="GRID21" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,30)" />
                <rect id="GRID22" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,30)" />
                <rect id="GRID23" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,30)" />
                <rect id="GRID24" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,30)" />
                <rect id="GRID25" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,30)" />
                <rect id="GRID26" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,30)" />
                <rect id="GRID27" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,30)" />
                <rect id="GRID28" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,30)" />
                <rect id="GRID29" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,30)" />
                <rect id="GRID30" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,40)" />
                <rect id="GRID31" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,40)" />
                <rect id="GRID32" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,40)" />
                <rect id="GRID33" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,40)" />
                <rect id="GRID34" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,40)" />
                <rect id="GRID35" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,40)" />
                <rect id="GRID36" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,40)" />
                <rect id="GRID37" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,40)" />
                <rect id="GRID38" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,40)" />
                <rect id="GRID39" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,40)" />
                <rect id="GRID40" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,50)" />
                <rect id="GRID41" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,50)" />
                <rect id="GRID42" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,50)" />
                <rect id="GRID43" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,50)" />
                <rect id="GRID44" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,50)" />
                <rect id="GRID45" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,50)" />
                <rect id="GRID46" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,50)" />
                <rect id="GRID47" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,50)" />
                <rect id="GRID48" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,50)" />
                <rect id="GRID49" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,50)" />
                <rect id="GRID50" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,60)" />
                <rect id="GRID51" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,60)" />
                <rect id="GRID52" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,60)" />
                <rect id="GRID53" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,60)" />
                <rect id="GRID54" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,60)" />
                <rect id="GRID55" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,60)" />
                <rect id="GRID56" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,60)" />
                <rect id="GRID57" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,60)" />
                <rect id="GRID58" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,60)" />
                <rect id="GRID59" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,60)" />
                <rect id="GRID60" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,70)" />
                <rect id="GRID61" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,70)" />
                <rect id="GRID62" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,70)" />
                <rect id="GRID63" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,70)" />
                <rect id="GRID64" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,70)" />
                <rect id="GRID65" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,70)" />
                <rect id="GRID66" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,70)" />
                <rect id="GRID67" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,70)" />
                <rect id="GRID68" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,70)" />
                <rect id="GRID69" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,70)" />
                <rect id="GRID70" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,80)" />
                <rect id="GRID71" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,80)" />
                <rect id="GRID72" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,80)" />
                <rect id="GRID73" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,80)" />
                <rect id="GRID74" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,80)" />
                <rect id="GRID75" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,80)" />
                <rect id="GRID76" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,80)" />
                <rect id="GRID77" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,80)" />
                <rect id="GRID78" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,80)" />
                <rect id="GRID79" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,80)" />
                <rect id="GRID80" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,90)" />
                <rect id="GRID81" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,90)" />
                <rect id="GRID82" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,90)" />
                <rect id="GRID83" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,90)" />
                <rect id="GRID84" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,90)" />
                <rect id="GRID85" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,90)" />
                <rect id="GRID86" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,90)" />
                <rect id="GRID87" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,90)" />
                <rect id="GRID88" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,90)" />
                <rect id="GRID89" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,90)" />
                <rect id="GRID90" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,100)" />
                <rect id="GRID91" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,100)" />
                <rect id="GRID92" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,100)" />
                <rect id="GRID93" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,100)" />
                <rect id="GRID94" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,100)" />
                <rect id="GRID95" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,100)" />
                <rect id="GRID96" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,100)" />
                <rect id="GRID97" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,100)" />
                <rect id="GRID98" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,100)" />
                <rect id="GRID99" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,100)" />
                <rect id="KEYGOOD" class="KeyUnit" width="10" height="10" style="fill:rgb(0,198,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,120)" />
                <text id="GoodKeyText" x="20" y="128" class="small" style="font-family:helvetica;font-size:xx-small;">GOOD Text</text>
                <rect id="KEYMEH" class="KeyUnit" width="10" height="10" style="fill:rgb(198,165,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,130)" />
                <text id="MehKeyText" x="20" y="138" class="small" style="font-family:helvetica;font-size:xx-small;">MEH Text</text>
                <rect id="KEYBAD" class="KeyUnit" width="10" height="10" style="fill:rgb(198,0,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,140)" />
                <text id="BadKeyText" x="20" y="148" class="small" style="font-family:helvetica;font-size:xx-small;">BAD Text</text>
                <rect id="KEYNONE" class="KeyUnit" width="10" height="10" style="fill:rgb(198,198,198);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,150)" />
                <text id="NoneKeyText" x="20" y="158" class="small" style="font-family:helvetica;font-size:xx-small;">UNDEFINED Text</text>
            </g>
        </svg>

        <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100mm"
        height="100mm"
        viewBox="0 0 100 162"
        version="1.1"
        id="vendor_availability_grid">
        <defs
            id="defs2" />
        <metadata
            id="metadata5">
            <rdf:RDF>
            <cc:Work
                rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type
                rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                <dc:title></dc:title>
            </cc:Work>
            </rdf:RDF>
        </metadata>
            <g id="Progress">
                <text id="ChartTitle" x="0" y="8" class="small" style="font-family:helvetica;font-size:x-small" zIndex=999999>Chart Title</text>
                <rect id="GRID00" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,10)" />
                <rect id="GRID01" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,10)" />
                <rect id="GRID02" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,10)" />
                <rect id="GRID03" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,10)" />
                <rect id="GRID04" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,10)" />
                <rect id="GRID05" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,10)" />
                <rect id="GRID06" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,10)" />
                <rect id="GRID07" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,10)" />
                <rect id="GRID08" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,10)" />
                <rect id="GRID09" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,10)" />
                <rect id="GRID10" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,20)" />
                <rect id="GRID11" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,20)" />
                <rect id="GRID12" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,20)" />
                <rect id="GRID13" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,20)" />
                <rect id="GRID14" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,20)" />
                <rect id="GRID15" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,20)" />
                <rect id="GRID16" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,20)" />
                <rect id="GRID17" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,20)" />
                <rect id="GRID18" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,20)" />
                <rect id="GRID19" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,20)" />
                <rect id="GRID20" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,30)" />
                <rect id="GRID21" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,30)" />
                <rect id="GRID22" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,30)" />
                <rect id="GRID23" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,30)" />
                <rect id="GRID24" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,30)" />
                <rect id="GRID25" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,30)" />
                <rect id="GRID26" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,30)" />
                <rect id="GRID27" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,30)" />
                <rect id="GRID28" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,30)" />
                <rect id="GRID29" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,30)" />
                <rect id="GRID30" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,40)" />
                <rect id="GRID31" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,40)" />
                <rect id="GRID32" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,40)" />
                <rect id="GRID33" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,40)" />
                <rect id="GRID34" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,40)" />
                <rect id="GRID35" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,40)" />
                <rect id="GRID36" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,40)" />
                <rect id="GRID37" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,40)" />
                <rect id="GRID38" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,40)" />
                <rect id="GRID39" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,40)" />
                <rect id="GRID40" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,50)" />
                <rect id="GRID41" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,50)" />
                <rect id="GRID42" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,50)" />
                <rect id="GRID43" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,50)" />
                <rect id="GRID44" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,50)" />
                <rect id="GRID45" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,50)" />
                <rect id="GRID46" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,50)" />
                <rect id="GRID47" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,50)" />
                <rect id="GRID48" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,50)" />
                <rect id="GRID49" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,50)" />
                <rect id="GRID50" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,60)" />
                <rect id="GRID51" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,60)" />
                <rect id="GRID52" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,60)" />
                <rect id="GRID53" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,60)" />
                <rect id="GRID54" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,60)" />
                <rect id="GRID55" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,60)" />
                <rect id="GRID56" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,60)" />
                <rect id="GRID57" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,60)" />
                <rect id="GRID58" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,60)" />
                <rect id="GRID59" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,60)" />
                <rect id="GRID60" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,70)" />
                <rect id="GRID61" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,70)" />
                <rect id="GRID62" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,70)" />
                <rect id="GRID63" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,70)" />
                <rect id="GRID64" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,70)" />
                <rect id="GRID65" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,70)" />
                <rect id="GRID66" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,70)" />
                <rect id="GRID67" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,70)" />
                <rect id="GRID68" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,70)" />
                <rect id="GRID69" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,70)" />
                <rect id="GRID70" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,80)" />
                <rect id="GRID71" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,80)" />
                <rect id="GRID72" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,80)" />
                <rect id="GRID73" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,80)" />
                <rect id="GRID74" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,80)" />
                <rect id="GRID75" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,80)" />
                <rect id="GRID76" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,80)" />
                <rect id="GRID77" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,80)" />
                <rect id="GRID78" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,80)" />
                <rect id="GRID79" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,80)" />
                <rect id="GRID80" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,90)" />
                <rect id="GRID81" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,90)" />
                <rect id="GRID82" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,90)" />
                <rect id="GRID83" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,90)" />
                <rect id="GRID84" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,90)" />
                <rect id="GRID85" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,90)" />
                <rect id="GRID86" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,90)" />
                <rect id="GRID87" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,90)" />
                <rect id="GRID88" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,90)" />
                <rect id="GRID89" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,90)" />
                <rect id="GRID90" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,100)" />
                <rect id="GRID91" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,100)" />
                <rect id="GRID92" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,100)" />
                <rect id="GRID93" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,100)" />
                <rect id="GRID94" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,100)" />
                <rect id="GRID95" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,100)" />
                <rect id="GRID96" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,100)" />
                <rect id="GRID97" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,100)" />
                <rect id="GRID98" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,100)" />
                <rect id="GRID99" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,100)" />
                <rect id="KEYGOOD" class="KeyUnit" width="10" height="10" style="fill:rgb(0,198,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,120)" />
                <text id="GoodKeyText" x="20" y="128" class="small" style="font-family:helvetica;font-size:xx-small;">GOOD Text</text>
                <rect id="KEYMEH" class="KeyUnit" width="10" height="10" style="fill:rgb(198,165,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,130)" />
                <text id="MehKeyText" x="20" y="138" class="small" style="font-family:helvetica;font-size:xx-small;">MEH Text</text>
                <rect id="KEYBAD" class="KeyUnit" width="10" height="10" style="fill:rgb(198,0,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,140)" />
                <text id="BadKeyText" x="20" y="148" class="small" style="font-family:helvetica;font-size:xx-small;">BAD Text</text>
                <rect id="KEYNONE" class="KeyUnit" width="10" height="10" style="fill:rgb(198,198,198);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,150)" />
                <text id="NoneKeyText" x="20" y="158" class="small" style="font-family:helvetica;font-size:xx-small;">UNDEFINED Text</text>
            </g>
        </svg>

        <svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns:svg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100mm"
        height="100mm"
        viewBox="0 0 100 162"
        version="1.1"
        id="delivery_grid">
        <defs
            id="defs2" />
        <metadata
            id="metadata5">
            <rdf:RDF>
            <cc:Work
                rdf:about="">
                <dc:format>image/svg+xml</dc:format>
                <dc:type
                rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                <dc:title></dc:title>
            </cc:Work>
            </rdf:RDF>
        </metadata>
            <g id="Progress">
                <text id="ChartTitle" x="0" y="8" class="small" style="font-family:helvetica;font-size:x-small" zIndex=999999>Chart Title</text>
                <rect id="GRID00" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,10)" />
                <rect id="GRID01" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,10)" />
                <rect id="GRID02" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,10)" />
                <rect id="GRID03" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,10)" />
                <rect id="GRID04" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,10)" />
                <rect id="GRID05" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,10)" />
                <rect id="GRID06" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,10)" />
                <rect id="GRID07" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,10)" />
                <rect id="GRID08" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,10)" />
                <rect id="GRID09" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,10)" />
                <rect id="GRID10" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,20)" />
                <rect id="GRID11" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,20)" />
                <rect id="GRID12" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,20)" />
                <rect id="GRID13" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,20)" />
                <rect id="GRID14" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,20)" />
                <rect id="GRID15" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,20)" />
                <rect id="GRID16" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,20)" />
                <rect id="GRID17" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,20)" />
                <rect id="GRID18" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,20)" />
                <rect id="GRID19" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,20)" />
                <rect id="GRID20" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,30)" />
                <rect id="GRID21" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,30)" />
                <rect id="GRID22" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,30)" />
                <rect id="GRID23" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,30)" />
                <rect id="GRID24" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,30)" />
                <rect id="GRID25" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,30)" />
                <rect id="GRID26" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,30)" />
                <rect id="GRID27" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,30)" />
                <rect id="GRID28" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,30)" />
                <rect id="GRID29" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,30)" />
                <rect id="GRID30" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,40)" />
                <rect id="GRID31" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,40)" />
                <rect id="GRID32" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,40)" />
                <rect id="GRID33" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,40)" />
                <rect id="GRID34" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,40)" />
                <rect id="GRID35" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,40)" />
                <rect id="GRID36" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,40)" />
                <rect id="GRID37" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,40)" />
                <rect id="GRID38" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,40)" />
                <rect id="GRID39" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,40)" />
                <rect id="GRID40" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,50)" />
                <rect id="GRID41" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,50)" />
                <rect id="GRID42" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,50)" />
                <rect id="GRID43" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,50)" />
                <rect id="GRID44" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,50)" />
                <rect id="GRID45" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,50)" />
                <rect id="GRID46" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,50)" />
                <rect id="GRID47" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,50)" />
                <rect id="GRID48" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,50)" />
                <rect id="GRID49" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,50)" />
                <rect id="GRID50" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,60)" />
                <rect id="GRID51" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,60)" />
                <rect id="GRID52" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,60)" />
                <rect id="GRID53" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,60)" />
                <rect id="GRID54" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,60)" />
                <rect id="GRID55" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,60)" />
                <rect id="GRID56" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,60)" />
                <rect id="GRID57" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,60)" />
                <rect id="GRID58" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,60)" />
                <rect id="GRID59" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,60)" />
                <rect id="GRID60" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,70)" />
                <rect id="GRID61" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,70)" />
                <rect id="GRID62" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,70)" />
                <rect id="GRID63" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,70)" />
                <rect id="GRID64" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,70)" />
                <rect id="GRID65" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,70)" />
                <rect id="GRID66" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,70)" />
                <rect id="GRID67" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,70)" />
                <rect id="GRID68" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,70)" />
                <rect id="GRID69" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,70)" />
                <rect id="GRID70" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,80)" />
                <rect id="GRID71" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,80)" />
                <rect id="GRID72" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,80)" />
                <rect id="GRID73" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,80)" />
                <rect id="GRID74" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,80)" />
                <rect id="GRID75" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,80)" />
                <rect id="GRID76" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,80)" />
                <rect id="GRID77" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,80)" />
                <rect id="GRID78" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,80)" />
                <rect id="GRID79" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,80)" />
                <rect id="GRID80" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,90)" />
                <rect id="GRID81" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,90)" />
                <rect id="GRID82" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,90)" />
                <rect id="GRID83" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,90)" />
                <rect id="GRID84" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,90)" />
                <rect id="GRID85" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,90)" />
                <rect id="GRID86" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,90)" />
                <rect id="GRID87" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,90)" />
                <rect id="GRID88" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,90)" />
                <rect id="GRID89" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,90)" />
                <rect id="GRID90" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(0,100)" />
                <rect id="GRID91" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(10,100)" />
                <rect id="GRID92" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(20,100)" />
                <rect id="GRID93" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(30,100)" />
                <rect id="GRID94" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(40,100)" />
                <rect id="GRID95" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(50,100)" />
                <rect id="GRID96" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(60,100)" />
                <rect id="GRID97" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(70,100)" />
                <rect id="GRID98" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(80,100)" />
                <rect id="GRID99" class="ProgUnit" width="10" height="10" style="fill:rgb(100,100,100);stroke-width:1;stroke:rgb(100,100,100)" transform="translate(90,100)" />
                <rect id="KEYGOOD" class="KeyUnit" width="10" height="10" style="fill:rgb(0,198,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,120)" />
                <text id="GoodKeyText" x="20" y="128" class="small" style="font-family:helvetica;font-size:xx-small;">GOOD Text</text>
                <rect id="KEYMEH" class="KeyUnit" width="10" height="10" style="fill:rgb(198,165,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,130)" />
                <text id="MehKeyText" x="20" y="138" class="small" style="font-family:helvetica;font-size:xx-small;">MEH Text</text>
                <rect id="KEYBAD" class="KeyUnit" width="10" height="10" style="fill:rgb(198,0,0);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,140)" />
                <text id="BadKeyText" x="20" y="148" class="small" style="font-family:helvetica;font-size:xx-small;">BAD Text</text>
                <rect id="KEYNONE" class="KeyUnit" width="10" height="10" style="fill:rgb(198,198,198);stroke-width:0.5;stroke:rgb(0,0,0)" transform="translate(0,150)" />
                <text id="NoneKeyText" x="20" y="158" class="small" style="font-family:helvetica;font-size:xx-small;">UNDEFINED Text</text>
            </g>
        </svg>
        </div>

        </div>
    </div>

        <!-- viewBox="-60 35 500 354" -->
        <div id="adlsvg" class="col-12 col-s-12">
            <div style="margin-left:30px;">
            <svg
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns="http://www.w3.org/2000/svg"
            id="svg2751"
            version="1.1"
            viewBox="0 0 420 297"
            height="297mm"
            width="420mm">
            <defs
                id="defs2745" />
            <metadata
                id="metadata2748">
                <rdf:RDF>
                <cc:Work
                    rdf:about="">
                    <dc:format>image/svg+xml</dc:format>
                    <dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                    <dc:title></dc:title>
                </cc:Work>
                </rdf:RDF>
            </metadata>
            <g
                id="layer1">
                <g
                transform="translate(45.541008,29.767339)"
                id="tblSource"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#f1f26f;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblSourceData"
                    width="24.803331"
                    height="16.497629"
                    x="-24.234447"
                    y="7.8187127"
                    ry="0.60279226" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblSourceHeader"
                    width="24.803331"
                    height="5.5750608"
                    x="-24.234447"
                    y="7.289546"
                    ry="0.60279226" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-19.910931"
                    y="11.192298"
                    id="tblSourceTitle"><tspan
                    id="tspan827"
                    x="-19.910931"
                    y="11.192298"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblSource</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-19.495541"
                    y="18.963461"
                    id="tblSourceType"><tspan
                    id="tspan831"
                    x="-19.495541"
                    y="18.963461"
                    style="stroke-width:0.26458332">Property</tspan></text>
                </g>
                <g
                transform="translate(46.109891,26.695367)"
                id="tblComments"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#f1f26f;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblCommentData-"
                    width="24.803331"
                    height="16.497629"
                    x="-24.803331"
                    y="30.781757"
                    ry="0.60279226" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblCommentHeader"
                    width="24.803331"
                    height="5.5750608"
                    x="-24.803331"
                    y="30.25259"
                    ry="0.60279226" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-22.596483"
                    y="34.155346"
                    id="tblCommentTitle"><tspan
                    id="tspan827-7"
                    x="-22.596483"
                    y="34.155346"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblComment</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-20.064425"
                    y="41.926506"
                    id="tblCommentType"><tspan
                    id="tspan831-3"
                    x="-20.064425"
                    y="41.926506"
                    style="stroke-width:0.26458332">Property</tspan></text>
                </g>
                <g
                transform="translate(45.388065,29.767339)"
                id="tblADLChangeManagement"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#f1f26f;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblADLChangeData"
                    width="56.109665"
                    height="16.174023"
                    x="-24.072643"
                    y="47.896297"
                    ry="0.59096837" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblADLChangeHeader"
                    width="56.12738"
                    height="5.2691746"
                    x="-24.081505"
                    y="47.358273"
                    ry="0.5697189" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-19.910933"
                    y="51.108078"
                    id="tblADLChangeTitle"><tspan
                    id="tspan827-9"
                    x="-19.910933"
                    y="51.108078"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblADLChangeManagement</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-5.2080455"
                    y="58.879242"
                    id="tblADLChangeType"><tspan
                    id="tspan831-1"
                    x="-5.2080455"
                    y="58.879242"
                    style="stroke-width:0.26458332">Property</tspan></text>
                </g>
                <g
                transform="translate(278.67793,-23.415639)"
                id="tblTagToAlias"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#f1f26f;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagToAliasData"
                    width="30.87245"
                    height="16.422802"
                    x="-24.424589"
                    y="76.443649"
                    ry="0.60005826" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagToAliasHeader"
                    width="30.988029"
                    height="5.5020366"
                    x="-24.425489"
                    y="75.913582"
                    ry="0.59489667" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-20.138485"
                    y="79.779816"
                    id="tblTagToAliasTitle"><tspan
                    id="tspan827-4"
                    x="-20.138485"
                    y="79.779816"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblTagToAlias</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-16.548092"
                    y="87.55098"
                    id="tblTagToAliasType"><tspan
                    id="tspan831-8"
                    x="-16.548092"
                    y="87.55098"
                    style="stroke-width:0.26458332">Property</tspan></text>
                </g>
                <g
                transform="translate(333.49751,13.724575)"
                id="tblTagAttribute"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#f1f26f;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagAttributeData"
                    width="33.459774"
                    height="16.393261"
                    x="-25.433807"
                    y="100.57909"
                    ry="0.59897882" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagAttributeHeader"
                    width="33.464203"
                    height="5.4751244"
                    x="-25.436024"
                    y="100.04771"
                    ry="0.59198684" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-21.162476"
                    y="103.90049"
                    id="tblTagAttributeTitle"><tspan
                    id="tspan827-5"
                    x="-21.162476"
                    y="103.90049"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblTagAttribute</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-16.513748"
                    y="111.67165"
                    id="tblTagAttributeType"><tspan
                    id="tspan831-88"
                    x="-16.513748"
                    y="111.67165"
                    style="stroke-width:0.26458332">Property</tspan></text>
                </g>
                <g
                transform="translate(326.78741,42.224412)"
                id="tblModelAttribute"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#f1f26f;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblModelAttributeData"
                    width="39.208981"
                    height="16.339853"
                    x="-24.895105"
                    y="121.88316"
                    ry="0.59702736" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblModelAttributeHeader"
                    width="39.3284"
                    height="5.4229317"
                    x="-24.89793"
                    y="121.35117"
                    ry="0.58634365" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-20.650476"
                    y="125.17785"
                    id="tblModelAttributeTitle"><tspan
                    id="tspan827-5-5"
                    x="-20.650476"
                    y="125.17785"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblModelAttribute</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-13.885087"
                    y="132.94902"
                    id="tblModelAttributeType"><tspan
                    id="tspan831-88-8"
                    x="-13.885087"
                    y="132.94902"
                    style="stroke-width:0.26458332">Property</tspan></text>
                </g>
                <g
                transform="translate(321.59266,-1.5370472)"
                id="tblDocumentAttribute"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#f1f26f;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblDocumentAttributeData"
                    width="44.626976"
                    height="16.296566"
                    x="-24.759684"
                    y="141.4747"
                    ry="0.59544575" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblDocumentAttributeHeader"
                    width="44.635326"
                    height="5.3823557"
                    x="-24.763865"
                    y="140.94136"
                    ry="0.58195651" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-20.536699"
                    y="144.74774"
                    id="tblDocumentAttributeTitle"><tspan
                    id="tspan827-5-5-3"
                    x="-20.536699"
                    y="144.74774"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblDocumentAttribute</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-10.596312"
                    y="152.51892"
                    id="tblDocumentAttributeType"><tspan
                    id="tspan831-88-8-8"
                    x="-10.596312"
                    y="152.51892"
                    style="stroke-width:0.26458332">Property</tspan></text>
                </g>
                <g
                transform="translate(58.079667,48.035712)"
                id="tblTagToTag"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#e4b3bc;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagToTagData"
                    width="30.87245"
                    height="16.422802"
                    x="154.94446"
                    y="4.9922991"
                    ry="0.60005826" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagToTagHeader"
                    width="30.988029"
                    height="5.5020366"
                    x="154.94356"
                    y="4.4622316"
                    ry="0.59489667" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="159.23056"
                    y="8.3284655"
                    id="tblTagToTagTitle"><tspan
                    id="tspan827-4-0"
                    x="159.23056"
                    y="8.3284655"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblTagToTag</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="159.646"
                    y="16.09963"
                    id="tblTagToTagType"><tspan
                    id="tspan831-8-2"
                    x="159.646"
                    y="16.09963"
                    style="stroke-width:0.26458332">Relationship</tspan></text>
                </g>
                <g
                transform="translate(78.097363,115.62071)"
                id="tblTagToModel"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#e4b3bc;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagToModelData"
                    width="30.87245"
                    height="16.422802"
                    x="155.17201"
                    y="25.699669"
                    ry="0.60005826" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagToModelHeader"
                    width="30.988029"
                    height="5.5020366"
                    x="155.17111"
                    y="25.169601"
                    ry="0.59489667" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="157.87064"
                    y="29.035835"
                    id="tblTagToModelTitle"><tspan
                    id="tspan827-4-0-8"
                    x="157.87064"
                    y="29.035835"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblTagToModel</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="159.87355"
                    y="36.806999"
                    id="tblTagToModelType"><tspan
                    id="tspan831-8-2-3"
                    x="159.87355"
                    y="36.806999"
                    style="stroke-width:0.26458332">Relationship</tspan></text>
                </g>
                <g
                transform="translate(-66.59329,70.494525)"
                id="tblTagToDocument"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#e4b3bc;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagToDocumentData"
                    width="38.533451"
                    height="16.346983"
                    x="155.20992"
                    y="46.217392"
                    ry="0.59728795" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagToDocumentHeader"
                    width="38.539665"
                    height="5.4306316"
                    x="155.20682"
                    y="45.685116"
                    ry="0.58717614" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="157.87064"
                    y="49.515648"
                    id="tblTagToDocumentTitle"><tspan
                    id="tspan827-4-0-8-3"
                    x="157.87064"
                    y="49.515648"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblTagToDocument</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="163.04851"
                    y="57.286812"
                    id="tblTagToDocumentType"><tspan
                    id="tspan831-8-2-3-0"
                    x="163.04851"
                    y="57.286812"
                    style="stroke-width:0.26458332">Relationship</tspan></text>
                </g>
                <g
                transform="translate(-114.33989,159.95534)"
                id="tblModelToDocument"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#e4b3bc;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblModelToDocumentData"
                    width="43.047638"
                    height="16.310101"
                    x="202.9577"
                    y="4.9359775"
                    ry="0.59594029" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblModelToDocumentHeader"
                    width="42.942421"
                    height="5.3960938"
                    x="202.95343"
                    y="4.4025283"
                    ry="0.58344185" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="205.59998"
                    y="8.2157917"
                    id="tblModelToDocumentTitle"><tspan
                    id="tspan827-4-0-8-3-9"
                    x="205.59998"
                    y="8.2157917"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblModelToDocument</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="212.89449"
                    y="15.986952"
                    id="tblModelToDocumentType"><tspan
                    id="tspan831-8-2-3-0-9"
                    x="212.89449"
                    y="15.986952"
                    style="stroke-width:0.26458332">Relationship</tspan></text>
                </g>
                <g
                transform="translate(11.151665,176.94167)"
                id="tblModelItemToDocument"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#e4b3bc;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblModelItemToDocumentData"
                    width="50.164116"
                    height="16.258642"
                    x="77.466743"
                    y="-35.746662"
                    ry="0.59406012" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblModelItemToDocumentHeader"
                    width="50.173939"
                    height="5.3458982"
                    x="77.461861"
                    y="-36.280739"
                    ry="0.57801455" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="80.083344"
                    y="-32.492577"
                    id="tblModelItemToDocumentTitle"><tspan
                    id="tspan827-4-0-8-3-9-0"
                    x="80.083344"
                    y="-32.492577"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblModelItemToDocument</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="90.023811"
                    y="-24.721415"
                    id="tblModelItemToDocumentType"><tspan
                    id="tspan831-8-2-3-0-9-6"
                    x="90.023811"
                    y="-24.721415"
                    style="stroke-width:0.26458332">Relationship</tspan></text>
                </g>
                <g
                transform="translate(-66.90722,55.75118)"
                id="tblDocumentToDocument"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#e4b3bc;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblDocumentToDocumentData"
                    width="50.164112"
                    height="16.258642"
                    x="88.325928"
                    y="46.263569"
                    ry="0.59406012" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblDocumentToDocumentHeader"
                    width="50.173935"
                    height="5.3458982"
                    x="88.321022"
                    y="45.729488"
                    ry="0.57801449" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="90.94252"
                    y="49.517654"
                    id="tblDocumentToDocumentTitle"><tspan
                    id="tspan827-4-0-8-3-9-0-0"
                    x="90.94252"
                    y="49.517654"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblDocumentToDocument</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="100.88297"
                    y="57.288815"
                    id="tblDocumentToDocumentType"><tspan
                    id="tspan831-8-2-3-0-9-6-6"
                    x="100.88297"
                    y="57.288815"
                    style="stroke-width:0.26458332">Relationship</tspan></text>
                </g>
                <g
                transform="translate(-147.53147,136.04348)"
                id="tblDocument"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#9ee1c9;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblDocumentData"
                    width="50.164108"
                    height="16.258642"
                    x="169.13486"
                    y="4.2799492"
                    ry="0.59406012" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblDocumentHeader"
                    width="50.173935"
                    height="5.3458982"
                    x="169.12996"
                    y="3.7458687"
                    ry="0.57801443" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="182.8638"
                    y="7.5340347"
                    id="tblDocumentTitle"><tspan
                    id="tspan827-4-0-8-3-9-0-0-5"
                    x="182.8638"
                    y="7.5340347"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblDocument</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="170.57956"
                    y="15.305193"
                    id="tblDocumentTypeDefinition"><tspan
                    id="tspan831-8-2-3-0-9-6-6-9"
                    x="170.57956"
                    y="15.305193"
                    style="stroke-width:0.26458332">MaterialisedPhysicalObject</tspan></text>
                </g>
                <g
                transform="translate(54.431798,168.18757)"
                id="tblModel"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#9ee1c9;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblModelData"
                    width="50.164108"
                    height="16.258642"
                    x="169.24863"
                    y="25.683737"
                    ry="0.59406012" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblModelHeader"
                    width="50.173935"
                    height="5.3458982"
                    x="169.24373"
                    y="24.567013"
                    ry="0.57801437" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="186.15251"
                    y="28.355179"
                    id="tblModelTitle"><tspan
                    id="tspan827-4-0-8-3-9-0-0-5-8"
                    x="186.15251"
                    y="28.355179"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblModel</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="170.69333"
                    y="36.126339"
                    id="tblModelType"><tspan
                    id="tspan831-8-2-3-0-9-6-6-9-9"
                    x="170.69333"
                    y="36.126339"
                    style="stroke-width:0.26458332">MaterialisedPhysicalObject</tspan></text>
                </g>
                <g
                transform="translate(-17.269595,95.3908)"
                id="tblModelItem"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#9ee1c9;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblModelItemData"
                    width="50.164108"
                    height="16.258642"
                    x="169.13486"
                    y="45.467133"
                    ry="0.59406012" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblModelItemHeader"
                    width="50.173935"
                    height="5.3458982"
                    x="169.12996"
                    y="44.933052"
                    ry="0.57801437" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="181.80548"
                    y="48.721218"
                    id="tblModelItemTitle"><tspan
                    id="tspan827-4-0-8-3-9-0-0-5-2"
                    x="181.80548"
                    y="48.721218"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblModelItem</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="170.57956"
                    y="56.492378"
                    id="tblModelItemType"><tspan
                    id="tspan831-8-2-3-0-9-6-6-9-6"
                    x="170.57956"
                    y="56.492378"
                    style="stroke-width:0.26458332">MaterialisedPhysicalObject</tspan></text>
                </g>
                <g
                transform="translate(183.90974,115.21857)"
                id="tblTag"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#bcadf2;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagData"
                    width="50.164108"
                    height="16.258642"
                    x="39.770683"
                    y="-22.343811"
                    ry="0.59406012" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagHeader"
                    width="50.173935"
                    height="5.3458982"
                    x="39.765785"
                    y="-22.877892"
                    ry="0.57801437" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="58.262062"
                    y="-19.089725"
                    id="tblTagTitle"><tspan
                    id="tspan827-4-0-8-3-9-0-0-5-2-1"
                    x="58.262062"
                    y="-19.089725"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblTag</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="42.802864"
                    y="-11.318565"
                    id="tblTagType"><tspan
                    id="tspan831-8-2-3-0-9-6-6-9-6-9"
                    x="42.802864"
                    y="-11.318565"
                    style="stroke-width:0.26458332">FunctionalPhysicalObject</tspan></text>
                </g>
                <g
                transform="translate(118.6019,244.61934)"
                id="tblOrganisation"
                class="mdmTable">
                <rect
                    style="opacity:1;fill:#a1cceb;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblOrganisationData"
                    width="55.591263"
                    height="16.224512"
                    x="102.36495"
                    y="-22.5543"
                    ry="0.59281301" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblOrganisationHeader"
                    width="55.602489"
                    height="5.3131685"
                    x="102.35935"
                    y="-23.089083"
                    ry="0.57447559" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="114.48936"
                    y="-19.31728"
                    id="tblOrganisationTitle"><tspan
                    id="tspan827-4-0-8-3-9-0-0-5-2-1-9"
                    x="114.48936"
                    y="-19.31728"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblOrganisation</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="105.38007"
                    y="-11.546123"
                    id="tblOrganisationType"><tspan
                    id="tspan831-8-2-3-0-9-6-6-9-6-9-0"
                    x="105.38007"
                    y="-11.546123"
                    style="stroke-width:0.26458332">ParticipatingRoleAndDomain</tspan></text>
                </g>
                <g
                transform="rotate(90,361.26135,86.411782)"
                id="ZeroOrMore">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260" />
                </g>
                <g
                transform="rotate(-90,298.97229,267.0294)"
                id="ZeroOrOne">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-6"
                    cx="346.78891"
                    cy="217.00433"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.04604,217.02327 h -1.53253"
                    id="path1258-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                    id="path1286-8" />
                </g>
                <g
                transform="rotate(-90,224.29547,212.46881)"
                id="OneOnlyOne">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6" />
                </g>
                <g
                transform="rotate(90,375.63465,100.61096)"
                id="ZeroOrMore-1">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-7"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-5" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-9" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-6" />
                </g>
                <g
                transform="rotate(-90,238.61769,198.2345)"
                id="OneOnlyOne-2">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8" />
                </g>
                <path
                id="path1196"
                d="M 234.76565,72.504437 V 89.65592"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path1198"
                d="m 263.32243,72.286778 -0.005,17.644993"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <g
                transform="rotate(90,353.53792,118.11162)"
                id="OneOnlyOne-2-7">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-1" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-8" />
                </g>
                <g
                transform="rotate(-90,260.34385,224.60028)"
                id="ZeroOrMore-5">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-9"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-7" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-5" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-38" />
                </g>
                <path
                id="path1251"
                d="m 248.71494,111.49416 v 26.13367"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <g
                transform="rotate(90,324.03486,137.67953)"
                id="ZeroOrMore-8">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9" />
                </g>
                <g
                transform="rotate(-90,281.57846,255.7302)"
                id="OneOnlyOne-2-6">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-43" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-3" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-3" />
                </g>
                <path
                id="path1306"
                d="m 248.78285,160.91729 v 29.47094"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <g
                transform="rotate(90,297.93209,163.9054)"
                id="ZeroOrMore-8-8">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8" />
                </g>
                <path
                id="path1335"
                d="m 248.86991,213.24236 v 5.13674"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <g
                transform="translate(-217.02667,-87.034394)"
                id="ZeroOrMore-8-8-5">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-6"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-2" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-9" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-1" />
                </g>
                <g
                transform="rotate(90,361.19948,125.68612)"
                id="OneOnlyOne-2-6-3-9">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-43-6-2" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-3-7-0" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-3-5-2" />
                </g>
                <g
                transform="translate(-205.44723,-62.395479)"
                id="ZeroOrMore-8-8-5-7">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-6-5"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-2-9" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-9-2" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-1-2" />
                </g>
                <g
                transform="translate(-212.41231,-38.540108)"
                id="ZeroOrMore-8-8-5-9">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-6-7"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-2-3" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-9-6" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-1-1" />
                </g>
                <g
                transform="rotate(180,248.14579,186.68993)"
                id="OneOnlyOne-2-6-3-3">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-43-6-1" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-3-7-9" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-3-5-4" />
                </g>
                <g
                transform="rotate(180,284.10297,212.93953)"
                id="OneOnlyOne-2-6-6">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-43-1" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-3-0" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-3-6" />
                </g>
                <g
                transform="rotate(-90,276.75007,260.29433)"
                id="ZeroOrOne-5">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-6-5"
                    cx="346.78891"
                    cy="217.00433"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.04604,217.02327 h -1.53253"
                    id="path1258-4-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                    id="path1286-8-7" />
                </g>
                <g
                transform="rotate(-90,288.88953,248.34671)"
                id="OneOnlyOne-2-6-7">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-43-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-3-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-3-3" />
                </g>
                <g
                transform="translate(-70.15078,-9.5480143)"
                id="ZeroOrMore-8-8-1">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0" />
                </g>
                <g
                transform="rotate(90,287.67456,100.7967)"
                id="ZeroOrMore-8-8-9">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-5"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-0" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-8" />
                </g>
                <g
                transform="rotate(-90,221.81308,262.81917)"
                id="ZeroOrOne-5-2">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-6-5-7"
                    cx="346.78891"
                    cy="217.00433"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.04604,217.02327 h -1.53253"
                    id="path1258-4-4-2" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                    id="path1286-8-7-2" />
                </g>
                <g
                transform="translate(-272.96128,-77.799344)"
                id="OneOnlyOne-2-6-3-3-9">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-43-6-1-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-3-7-9-9" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-3-5-4-0" />
                </g>
                <g
                transform="translate(-272.88841,-73.659394)"
                id="OneOnlyOne-2-6-3-3-9-9">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-43-6-1-4-7" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-3-7-9-9-7" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-3-5-4-0-6" />
                </g>
                <g
                transform="translate(-272.80134,-69.654484)"
                id="OneOnlyOne-2-6-3-3-9-6">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-43-6-1-4-5" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-3-7-9-9-6" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-3-5-4-0-3" />
                </g>
                <g
                transform="rotate(90,242.62525,16.827829)"
                id="ZeroOrMore-8-8-9-9">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-5-3"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-0-9" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-4-0" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-8-8" />
                </g>
                <g
                transform="rotate(-90,153.89779,330.31688)"
                id="OneOnlyOne-2-6-7-8">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-43-4-5" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-3-4-7" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-3-3-4" />
                </g>
                <g
                transform="rotate(90,223.50886,35.847429)"
                id="ZeroOrMore-8-8-9-9-5">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-5-3-9"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-0-9-7" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-4-0-5" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-8-8-3" />
                </g>
                <g
                transform="rotate(180,216.38414,169.26087)"
                id="ZeroOrMore-8-8-5-1">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-6-8"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-2-96" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-9-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-1-3" />
                </g>
                <g
                transform="rotate(180,216.29708,181.1494)"
                id="ZeroOrMore-8-8-5-1-6">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-6-8-0"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-2-96-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-9-4-8" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-1-3-8" />
                </g>
                <g
                transform="rotate(180,216.21001,193.72569)"
                id="ZeroOrMore-8-8-5-1-7">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-6-8-7"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-2-96-6" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-9-4-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-1-3-3" />
                </g>
                <g
                transform="rotate(180,284.10297,162.35571)"
                id="OneOnlyOne-2-6-3-3-2">
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.92044,222.93459 h -2.18675"
                    id="path1258-3-9-1-43-6-1-5" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                    id="path1286-7-7-3-7-9-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                    id="path1286-7-6-8-3-5-4-05" />
                </g>
                <g
                transform="rotate(90,343.45848,108.31112)"
                id="ZeroOrOne-5-9">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-6-5-2"
                    cx="346.78891"
                    cy="217.00433"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 346.04604,217.02327 h -1.53253"
                    id="path1258-4-4-24" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                    id="path1286-8-7-7" />
                </g>
                <path
                id="path1669"
                d="M 149.37112,150.44529 H 141.8706"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path1671"
                d="m 234.76565,112.37946 v 11.92768 h -58.68071 v 12.71125"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path1673"
                d="m 175.56197,160.35138 v 13.756 h 57.89832 v 15.23609"
                style="fill:none;stroke:#000000;stroke-width:0.26399124px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path1675"
                d="m 134.81691,174.28151 h 17.84799 v 28.64385 h 68.4318"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path1677"
                d="m 221.28548,101.77685 h -69.49122 v 24.01037 h -21.50465 v 0"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <g
                transform="rotate(180,325.98417,168.57878)"
                id="ZeroOrMore-8-8-1-8">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-6"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-2" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-8" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-4" />
                </g>
                <g
                transform="rotate(180,320.42486,181.35592)"
                id="ZeroOrMore-8-8-1-2">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-4"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-0" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-6" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-2" />
                </g>
                <g
                transform="rotate(180,322.95717,193.34974)"
                id="ZeroOrMore-8-8-1-9">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-0"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-8" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-1" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-3" />
                </g>
                <path
                id="path1734"
                d="m 263.95101,111.4071 v 12.8597 h 40.63085"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path1736"
                d="m 263.47741,190.31582 v -16.3676 h 35.07126"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path1738"
                d="M 46.515521,137.29425 V 121.49646"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path1740"
                d="m 74.032033,149.27519 h 11.32364 v -0.0753 0"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path1742"
                d="m 85.478803,125.56045 h -4.92505 v 19.57542 h -6.40256"
                style="fill:none;stroke:#000000;stroke-width:0.2654081px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path1744"
                d="m 84.920793,174.5687 h -5.14964 v -21.22754 h -5.65206 v -0.0611"
                style="fill:none;stroke:#000000;stroke-width:0.26600134px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <g
                transform="translate(-70.15078,-111.41214)"
                id="ZeroOrMore-8-8-5-3">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-6-80"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-2-5" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-9-66" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-1-4" />
                </g>
                <path
                id="path1797"
                d="m 277.25257,101.49653 h 77.74757"
                style="fill:none;stroke:#000000;stroke-width:0.14007649px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <g
                transform="translate(-2.8389727,-85.686854)"
                id="ZeroOrMore-8-8-1-2-96">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-4-10"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-0-42" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-6-2" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-2-20" />
                </g>
                <g
                transform="translate(-2.7158437,-90.242514)"
                id="ZeroOrMore-8-8-1-2-5">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-4-5"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-0-29" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-6-0" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-2-28" />
                </g>
                <g
                transform="translate(-2.8348927,-94.665634)"
                id="ZeroOrMore-8-8-1-2-3">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-4-80"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-0-40" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-6-91" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-2-96" />
                </g>
                <g
                transform="translate(-3.1467727,-35.93574)"
                id="ZeroOrMore-8-8-1-2-96-2">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-4-10-5"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-0-42-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-6-2-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-2-20-9" />
                </g>
                <g
                transform="translate(-3.0236327,-40.4914)"
                id="ZeroOrMore-8-8-1-2-5-9">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-4-5-3"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-0-29-6" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-6-0-0" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-2-28-5" />
                </g>
                <g
                transform="translate(-3.1427037,-44.914519)"
                id="ZeroOrMore-8-8-1-2-3-0">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-4-80-2"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-0-40-9" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-6-91-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-2-96-3" />
                </g>
                <g
                transform="translate(-2.8209147,-64.616184)"
                id="ZeroOrMore-8-8-1-2-5-4">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-4-5-6"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-0-29-9" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-6-0-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-2-28-2" />
                </g>
                <g
                transform="translate(-2.8093947,-69.561684)"
                id="ZeroOrMore-8-8-1-2-3-2">
                <ellipse
                    style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="path1250-3-6-4-4-80-6"
                    cx="346.58984"
                    cy="212.90901"
                    rx="0.71110511"
                    ry="0.74721688" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.4864,0.98504"
                    id="path1254-1-0-9-0-40-4" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 h -1.53253"
                    id="path1258-8-4-2-6-91-1" />
                <path
                    style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                    d="m 345.84698,212.928 -1.51831,-1.02924"
                    id="path1260-9-8-0-2-96-2" />
                </g>
                <path
                id="path1797-7"
                d="m 277.04568,203.37998 h 77.74756"
                style="fill:none;stroke:#000000;stroke-width:0.14007649px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path2387"
                d="m 46.38624,159.48089 v 90.744 H 287.8367 V 149.6308 h 5.54066"
                style="fill:none;stroke:#000000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path3996"
                d="m 344.57353,118.1467 h 10.3277"
                style="fill:none;stroke:#000000;stroke-width:0.2465975px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path3996-4"
                d="m 344.706,122.63683 h 10.3277"
                style="fill:none;stroke:#000000;stroke-width:0.2465975px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path3996-9"
                d="m 344.59034,127.20555 h 10.3277"
                style="fill:none;stroke:#000000;stroke-width:0.2465975px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path3996-94"
                d="m 344.59034,143.34065 h 10.3277"
                style="fill:none;stroke:#000000;stroke-width:0.2465975px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path3996-5"
                d="m 344.5325,148.25636 h 10.3277"
                style="fill:none;stroke:#000000;stroke-width:0.2465975px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path3996-93"
                d="m 344.30118,167.97704 h 10.3277"
                style="fill:none;stroke:#000000;stroke-width:0.2465975px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path3996-57"
                d="m 344.24335,176.99881 h 10.3277"
                style="fill:none;stroke:#000000;stroke-width:0.2465975px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <path
                id="path3996-0"
                d="m 344.41684,172.4301 h 10.3277"
                style="fill:none;stroke:#000000;stroke-width:0.2465975px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                <g
                transform="translate(415.60915,32.401684)"
                id="tblTagAttribute-8">
                <rect
                    rx="1.143214"
                    style="opacity:1;fill:#caccca;fill-opacity:1;stroke:#000009;stroke-width:0.55117345;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagAttributeData-1"
                    width="32.517193"
                    height="112.97323"
                    x="-60.593296"
                    y="62.494526"
                    ry="4.1278286" />
                <rect
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.49365529;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    id="tblTagAttributeHeader-9"
                    width="32.603031"
                    height="5.4780264"
                    x="-60.609005"
                    y="61.490364"
                    ry="0.59230059" />
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-56.793255"
                    y="65.344604"
                    id="tblTagAttributeTitle-9"><tspan
                    id="tspan827-5-7"
                    x="-56.793255"
                    y="65.344604"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">RDL Interface</tspan></text>
                <text
                    xml:space="preserve"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                    x="-56.907032"
                    y="104.33662"
                    id="tblTagAttributeType-8"><tspan
                    id="tspan831-88-2"
                    x="-56.907032"
                    y="104.33662"
                    style="stroke-width:0.26458332">DataExchange</tspan></text>
                <flowRoot
                    transform="matrix(0.26458333,0,0,0.26458333,-416.3149,-34.048442)"
                    style="font-style:normal;font-weight:normal;font-size:40px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none"
                    id="flowRoot4103"
                    xml:space="preserve"><flowRegion
                    id="flowRegion4105"><rect
                        y="144.46762"
                        x="291.63733"
                        height="72.020195"
                        width="180.49506"
                        id="rect4107" /></flowRegion><flowPara
                    id="flowPara4109">ADL</flowPara></flowRoot>    </g>
            </g>
            </svg>

            </div>
        </div>

        <div id="rdlsvg" class="col-12 col-s-12">
            <div style"margin-left:30px>
                <svg
                xmlns:dc="http://purl.org/dc/elements/1.1/"
                xmlns:cc="http://creativecommons.org/ns#"
                xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                xmlns:svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                id="svg2935"
                version="1.1"
                viewBox="0 0 420 297"
                height="297mm"
                width="420mm">
                <defs
                    id="defs2929" />
                <metadata
                    id="metadata2932">
                    <rdf:RDF>
                    <cc:Work
                        rdf:about="">
                        <dc:format>image/svg+xml</dc:format>
                        <dc:type
                        rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                        <dc:title></dc:title>
                    </cc:Work>
                    </rdf:RDF>
                </metadata>
                <g
                    id="layer1">
                    <g
                    transform="matrix(0.855,0,0,0.855,87.905916,-76.704809)"
                    id="tblRDLChangeManagement"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#f1f26f;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblRDLChangeData"
                        width="56.109665"
                        height="16.174023"
                        x="-34.881435"
                        y="164.5219"
                        ry="0.59096837" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblRDLChangeHeader"
                        width="56.12738"
                        height="5.2691746"
                        x="-34.890297"
                        y="163.98387"
                        ry="0.5697189" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="-30.719723"
                        y="167.73367"
                        id="tblRDLChangeTitle"><tspan
                        id="tspan827-9-5"
                        x="-30.719723"
                        y="167.73367"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblRDLChangeManagement</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="-16.016836"
                        y="175.50484"
                        id="tblRDLChangeType"><tspan
                        id="tspan831-1-1"
                        x="-16.016836"
                        y="175.50484"
                        style="stroke-width:0.26458332">Property</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,79.344555,-52.33049)"
                    id="tblAttributePickListValue"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#f1f26f;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblAttributePicklistValueData"
                        width="56.109665"
                        height="16.174023"
                        x="-24.86908"
                        y="168.61786"
                        ry="0.59096837" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblAttributePicklistValueHeader"
                        width="56.12738"
                        height="5.2691746"
                        x="-24.877941"
                        y="168.07983"
                        ry="0.5697189" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="-20.707367"
                        y="171.82964"
                        id="tblAttributePicklistValueTitle"><tspan
                        id="tspan827-9-5-6"
                        x="-20.707367"
                        y="171.82964"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblAttributePicklistValue</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="-6.0044804"
                        y="179.6008"
                        id="tblAttributePicklistValueType"><tspan
                        id="tspan831-1-1-6"
                        x="-6.0044804"
                        y="179.6008"
                        style="stroke-width:0.26458332">Property</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,79.411833,-36.529218)"
                    id="tblAttributeToAttributePickListValue"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#f1f26f;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblAttributeToAttributePicklistValueData"
                        width="69.575661"
                        height="16.100588"
                        x="-24.94614"
                        y="187.99663"
                        ry="0.58828521" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblAttributeToAttributePicklistValueHeader"
                        width="69.596634"
                        height="5.1989923"
                        x="-24.956627"
                        y="187.45699"
                        ry="0.56213063" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="-20.291977"
                        y="191.17169"
                        id="tblAttributeToAttributePicklistValueTitle"><tspan
                        id="tspan827-9-5-6-6"
                        x="-20.291977"
                        y="191.17169"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblAttributeToAttributePicklistValue</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="1.2900741"
                        y="198.94286"
                        id="tblAttributeToAttributePicklistValueType"><tspan
                        id="tspan831-1-1-6-8"
                        x="1.2900741"
                        y="198.94286"
                        style="stroke-width:0.26458332">Property</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,49.789695,92.238643)"
                    id="tblDiscipline"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#52e0e8;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblDisciplineData"
                        width="37.390236"
                        height="16.341545"
                        x="270.0134"
                        y="39.623417"
                        ry="0.59708917" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblDisciplineHeader"
                        width="37.284679"
                        height="5.4271932"
                        x="270.00928"
                        y="39.090141"
                        ry="0.58680427" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="277.96289"
                        y="42.918953"
                        id="tblDisciplineTitle"><tspan
                        id="tspan827-4-0-8-3-9-0-0-5-2-1-9-7"
                        x="277.96289"
                        y="42.918953"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblDiscipline</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="284.72885"
                        y="50.690109"
                        id="tblDisciplineType"><tspan
                        id="tspan831-8-2-3-0-9-6-6-9-6-9-0-4"
                        x="284.72885"
                        y="50.690109"
                        style="stroke-width:0.26458332">Role</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-173.01105,152.62371)"
                    id="tblUnitOfMeasure"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#52e0e8;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblUOMData"
                        width="48.918633"
                        height="16.264709"
                        x="270.27936"
                        y="19.409571"
                        ry="0.59428179" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblUOMHeader"
                        width="49.04147"
                        height="5.3511996"
                        x="270.27484"
                        y="18.875872"
                        ry="0.57858759" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="278.19046"
                        y="22.666689"
                        id="tblUOMTitle"><tspan
                        id="tspan827-4-0-8-3-9-0-0-5-2-1-9-7-5"
                        x="278.19046"
                        y="22.666689"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblUnitOfMeasure</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="289.71899"
                        y="30.437845"
                        id="tblUOMType"><tspan
                        id="tspan831-8-2-3-0-9-6-6-9-6-9-0-4-5"
                        x="289.71899"
                        y="30.437845"
                        style="stroke-width:0.26458332">Role</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-17.202155,122.50673)"
                    id="tblFunctionalClass"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#98a0c0;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblFunctionalClassData"
                        width="50.164108"
                        height="16.258642"
                        x="269.7135"
                        y="-20.409609"
                        ry="0.59406012" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblFunctionalClassHeader"
                        width="50.173935"
                        height="5.3458982"
                        x="269.70859"
                        y="-20.943689"
                        ry="0.57801437" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="279.20892"
                        y="-17.155523"
                        id="tblFunctionalClassTitle"><tspan
                        id="tspan827-4-0-8-3-9-0-0-5-8-6"
                        x="279.20892"
                        y="-17.155523"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblFunctionalClass</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="272.74573"
                        y="-9.3843641"
                        id="tblFunctionalClassType"><tspan
                        id="tspan831-8-2-3-0-9-6-6-9-9-9"
                        x="272.74573"
                        y="-9.3843641"
                        style="stroke-width:0.26458332">ClassOfFunctionalObject</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-14.785575,190.94771)"
                    id="tblPhysicalClass"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#16c888;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblPhysicalClassData"
                        width="50.164108"
                        height="16.258642"
                        x="270.05484"
                        y="-0.043570712"
                        ry="0.59406012" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblPhysicalClassHeader"
                        width="50.173935"
                        height="5.3458982"
                        x="270.04993"
                        y="-0.5776512"
                        ry="0.57801443" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="281.13791"
                        y="3.2105148"
                        id="tblDocumentTitle-8"><tspan
                        id="tspan827-4-0-8-3-9-0-0-5-5"
                        x="281.13791"
                        y="3.2105148"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblPhysicalClass</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="274.67459"
                        y="10.981673"
                        id="tblPhysicalClassType"><tspan
                        id="tspan831-8-2-3-0-9-6-6-9-7"
                        x="274.67459"
                        y="10.981673"
                        style="stroke-width:0.26458332">ClassOfPhysicalObject</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-6.8167265,122.46417)"
                    id="tblFunctionalClassToDiscDocType"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#e64e56;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblFunctionalClToDiscDocumentTypeData"
                        width="69.575661"
                        height="16.100588"
                        x="335.78305"
                        y="-20.555351"
                        ry="0.58828521" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblFunctionalClToDiscDocumentTypeHeader"
                        width="69.596634"
                        height="5.1989923"
                        x="335.77258"
                        y="-21.094994"
                        ry="0.56213063" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="338.8497"
                        y="-17.380287"
                        id="tblFunctionalClToDiscDocumentTypeTitle"><tspan
                        id="tspan827-9-5-6-6-1"
                        x="338.8497"
                        y="-17.380287"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblFunctionalClToDiscDocumentType</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="353.02332"
                        y="-9.6091242"
                        id="tblFunctionalClToDiscDocumentTypeType"><tspan
                        id="tspan831-1-1-6-8-9"
                        x="353.02332"
                        y="-9.6091242"
                        style="stroke-width:0.26458332">ClassOfRelationship</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-7.0398302,188.79835)"
                    id="tblPhysicalClassToDiscDocType"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#e64e56;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblPhysicalClToDiscDocumentTypeData"
                        width="69.575661"
                        height="16.100588"
                        x="335.66925"
                        y="1.8730829"
                        ry="0.58828521" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblPhysicalClToDiscDocumentTypeHeader"
                        width="69.596634"
                        height="5.1989923"
                        x="335.65878"
                        y="1.3334405"
                        ry="0.56213063" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="338.7359"
                        y="5.0481472"
                        id="tblPhysicalClToDiscDocumentTypeTitle"><tspan
                        id="tspan827-9-5-6-6-1-3"
                        x="338.7359"
                        y="5.0481472"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblPhysicalClToDiscDocumentType</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="352.90952"
                        y="12.81931"
                        id="tblPhysicalClToDiscDocumentTypeType"><tspan
                        id="tspan831-1-1-6-8-9-8"
                        x="352.90952"
                        y="12.81931"
                        style="stroke-width:0.26458332">ClassOfRelationship</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-78.998805,126.13787)"
                    id="tblFunctionalClassToPhysicalClass"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#e64e56;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblFunctionalClToPhysicalClData"
                        width="69.575661"
                        height="16.100588"
                        x="335.55548"
                        y="24.955347"
                        ry="0.58828521" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblFunctionalClToPhysicalClHeader"
                        width="69.596634"
                        height="5.1989923"
                        x="335.54501"
                        y="24.415705"
                        ry="0.56213063" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="344.97223"
                        y="28.130411"
                        id="tblFunctionalClToPhysicalClTitle"><tspan
                        id="tspan827-9-5-6-6-1-8"
                        x="344.97223"
                        y="28.130411"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblFunctionalClToPhysicalCl</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="352.79575"
                        y="35.901573"
                        id="tblFunctionalClToPhysicalClType"><tspan
                        id="tspan831-1-1-6-8-9-7"
                        x="352.79575"
                        y="35.901573"
                        style="stroke-width:0.26458332">ClassOfRelationship</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-219.11263,141.29129)"
                    id="tblFunctionalClassToAttribute"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#e64e56;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblFunctionalClassToAttributeData"
                        width="69.575661"
                        height="16.100588"
                        x="413.37878"
                        y="-20.555351"
                        ry="0.58828521" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblFunctionalClassToAttributeHeader"
                        width="69.596634"
                        height="5.1989923"
                        x="413.36832"
                        y="-21.094994"
                        ry="0.56213063" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="422.79553"
                        y="-17.380287"
                        id="tblFunctionalClassToAttributeTitle"><tspan
                        id="tspan827-9-5-6-6-1-30"
                        x="422.79553"
                        y="-17.380287"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblFunctionalClassToAttribute</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="430.61905"
                        y="-9.6091232"
                        id="tblFunctionalClassToAttributeType"><tspan
                        id="tspan831-1-1-6-8-9-9"
                        x="430.61905"
                        y="-9.6091232"
                        style="stroke-width:0.26458332">ClassOfRelationship</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-218.57702,167.23071)"
                    id="tblPhysicalClassToAttribute"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#e64e56;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblPhysicalClassToAttributeData"
                        width="69.575661"
                        height="16.100588"
                        x="413.26498"
                        y="1.8730829"
                        ry="0.58828521" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblPhysicalClassToAttributeHeader"
                        width="69.596634"
                        height="5.1989923"
                        x="413.25452"
                        y="1.3334405"
                        ry="0.56213063" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="425.32761"
                        y="5.0481472"
                        id="tblPhysicalClassToAttributeTitle"><tspan
                        id="tspan827-9-5-6-6-1-3-0"
                        x="425.32761"
                        y="5.0481472"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblPhysicalClassToAttribute</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="430.50525"
                        y="12.819307"
                        id="tblPhysicalClassToAttributeType"><tspan
                        id="tspan831-1-1-6-8-9-8-9"
                        x="430.50525"
                        y="12.819307"
                        style="stroke-width:0.26458332">ClassOfRelationship</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-218.4099,124.30587)"
                    id="tblDiscDocTypeToAttribute"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#e64e56;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblDisciplineDocTypeToAttributeData"
                        width="69.575661"
                        height="16.100588"
                        x="413.15121"
                        y="24.955347"
                        ry="0.58828521" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblDisciplineDocTypeToAttributeHeader"
                        width="69.596634"
                        height="5.1989923"
                        x="413.14075"
                        y="24.415705"
                        ry="0.56213063" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="419.39291"
                        y="28.130411"
                        id="tblDisciplineDocTypeToAttributeTitle"><tspan
                        id="tspan827-9-5-6-6-1-8-2"
                        x="419.39291"
                        y="28.130411"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblDisciplineDocTypeToAttribute</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="430.39148"
                        y="35.901566"
                        id="tblDisciplineDocTypeToAttributeType"><tspan
                        id="tspan831-1-1-6-8-9-7-4"
                        x="430.39148"
                        y="35.901566"
                        style="stroke-width:0.26458332">ClassOfRelationship</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-105.46913,-48.953231)"
                    id="tblTagFormat"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#e6ac4e;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblTagFormatData"
                        width="69.575661"
                        height="16.100588"
                        x="373.32938"
                        y="132.8157"
                        ry="0.58828521" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblTagFormatHeader"
                        width="69.596634"
                        height="5.1989923"
                        x="373.31891"
                        y="132.27606"
                        ry="0.56213063" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="394.91711"
                        y="135.99077"
                        id="tblTagFormatTitle"><tspan
                        id="tspan827-9-5-6-6-1-8-5"
                        x="394.91711"
                        y="135.99077"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblTagFormat</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="377.86945"
                        y="143.76193"
                        id="tblTagFormatType"><tspan
                        id="tspan831-1-1-6-8-9-7-3"
                        x="377.86945"
                        y="143.76193"
                        style="stroke-width:0.26458332">ClassOfInformationRepresentation</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,31.399935,13.634595)"
                    id="tblDocumentType"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#e6ac4e;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblDocumentTypeData"
                        width="69.575661"
                        height="16.100588"
                        x="374.12579"
                        y="155.34351"
                        ry="0.58828521" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblDocumentTypeHeader"
                        width="69.596634"
                        height="5.1989923"
                        x="374.11533"
                        y="154.80386"
                        ry="0.56213063" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="393.59683"
                        y="158.51857"
                        id="tblDocumentTypeTitle"><tspan
                        id="tspan827-9-5-6-6-1-8-5-5"
                        x="393.59683"
                        y="158.51857"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblDocumentType</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="384.48679"
                        y="166.28973"
                        id="tblDocumentTypeType"><tspan
                        id="tspan831-1-1-6-8-9-7-3-4"
                        x="384.48679"
                        y="166.28973"
                        style="stroke-width:0.26458332">ClassOfInformationObject</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-40.181223,-4.8408943)"
                    id="tblDisciplineDocumentType"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#e6ac4e;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblDisciplineDocumentTypeData"
                        width="69.575661"
                        height="16.100588"
                        x="374.5809"
                        y="177.07487"
                        ry="0.58828521" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblDisciplineDocumentTypeHeader"
                        width="69.596634"
                        height="5.1989923"
                        x="374.57043"
                        y="176.53523"
                        ry="0.56213063" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="385.58514"
                        y="180.24994"
                        id="tblDisciplineDocumentTypeTitle"><tspan
                        id="tspan827-9-5-6-6-1-8-5-5-9"
                        x="385.58514"
                        y="180.24994"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblDisciplineDocumentType</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="385.47107"
                        y="188.0211"
                        id="tblDisciplineDocumentTypeType"><tspan
                        id="tspan831-1-1-6-8-9-7-3-4-5"
                        x="385.47107"
                        y="188.0211"
                        style="stroke-width:0.26458332">ClassOfInformationObject</tspan></text>
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-329.81144,90.310982)"
                    id="tblAttribute"
                    class="mdmTable">
                    <rect
                        style="opacity:1;fill:#b5b678;fill-opacity:1;stroke:#000009;stroke-width:0.66100001;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblAttributeData"
                        width="56.109665"
                        height="16.174023"
                        x="453.67593"
                        y="65.991226"
                        ry="0.59096837" />
                    <rect
                        style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.66145831;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="tblAttributeHeader"
                        width="56.12738"
                        height="5.2691746"
                        x="453.66708"
                        y="65.453201"
                        ry="0.5697189" />
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-weight:normal;font-size:10.58333302px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="471.06702"
                        y="69.203003"
                        id="tblAttributeTitle"><tspan
                        id="tspan827-9-5-1"
                        x="471.06702"
                        y="69.203003"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.26458332">tblAttribute</tspan></text>
                    <text
                        xml:space="preserve"
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.88055563px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.26458332"
                        x="467.24881"
                        y="76.974167"
                        id="tblAttributeType"><tspan
                        id="tspan831-1-1-9"
                        x="467.24881"
                        y="76.974167"
                        style="stroke-width:0.26458332">ClassOfProperty</tspan></text>
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,71.218823,484.88827)"
                    id="OneOrMore">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.03181,210.34962 -1.4864,0.98503"
                        id="path1254-3" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.68603,210.34962 h -2.18675"
                        id="path1258-3" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.03181,210.34962 -1.51831,-1.02925"
                        id="path1260-3" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.74643,209.27786 v 2.14753 h -0.0285"
                        id="path1286" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,507.88669,297.22851)"
                    id="ZeroOrOne-5-0">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,352.55855,313.33713)"
                    id="ZeroOrOne-5-0-2">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0-6"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4-7" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6-5" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,352.51221,316.96594)"
                    id="ZeroOrOne-5-0-6">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0-9"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6-7" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,352.51224,320.01884)"
                    id="ZeroOrOne-5-0-28">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0-2"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6-9" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,352.38758,359.69087)"
                    id="ZeroOrOne-5-0-6-8">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0-9-8"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4-8-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6-7-2" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,352.38762,363.637)"
                    id="ZeroOrOne-5-0-28-8">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0-2-8"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4-9-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6-9-6" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,-106.57733,462.98835)"
                    id="ZeroOrOne-5-8">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-3"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-3" />
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-194.35382,-8.0729338)"
                    id="ZeroOrOne-5-0-28-8-3">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0-2-8-3"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4-9-8-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6-9-6-0" />
                    </g>
                    <g
                    transform="matrix(0,0.855,-0.855,0,261.29573,-111.00392)"
                    id="ZeroOrMore-8-8-4">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-6-7"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-0-6" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-4-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-8-9" />
                    </g>
                    <path
                    id="path2174"
                    d="m 79.184356,185.87707 v 6.02957 h 32.083294 v -14.66452 h -8.33717"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0,0.855,-0.855,0,260.92354,-133.70786)"
                    id="ZeroOrMore-8-0">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-68"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-7" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-0" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,-106.87509,440.58216)"
                    id="ZeroOrOne-5-8-3">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-3-3"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-8-3" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-3-7" />
                    </g>
                    <g
                    transform="matrix(0,0.855,-0.855,0,260.55133,-156.48625)"
                    id="ZeroOrMore-8-3">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2" />
                    </g>
                    <path
                    id="path2254"
                    d="m 78.961055,165.77848 v -2.60536"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path2256"
                    d="m 78.588864,143.3723 v -2.97757"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0.855,0,0,0.855,-188.56274,-40.851371)"
                    id="OneOnlyOne-2-6-7-6">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-58" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-79" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-6" />
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-188.63719,-36.75723)"
                    id="OneOnlyOne-2-6-7-0">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-4" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-1" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-0" />
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-188.63717,-32.886379)"
                    id="OneOnlyOne-2-6-7-4">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-70" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-8" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,352.58885,340.10174)"
                    id="OneOnlyOne-2-6-7-62">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-47" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-3" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,352.51443,344.27033)"
                    id="OneOnlyOne-2-6-7-9">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-2" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-30" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,352.58885,348.36448)"
                    id="OneOnlyOne-2-6-7-1">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-7" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-89" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-1" />
                    </g>
                    <rect
                    ry="3.737535"
                    y="105.67442"
                    x="7.7050562"
                    height="102.29139"
                    width="27.788616"
                    id="tblTagAttributeData-1"
                    style="opacity:1;fill:#caccca;fill-opacity:1;stroke:#000009;stroke-width:0.48483846;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                    rx="0.97697037" />
                    <rect
                    ry="0.50641698"
                    y="104.80906"
                    x="7.6848311"
                    height="4.6837125"
                    width="27.875591"
                    id="tblTagAttributeHeader-9"
                    style="opacity:1;fill:#aaaaaa;fill-opacity:1;stroke:#000009;stroke-width:0.42207527;stroke-linecap:square;stroke-linejoin:miter;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1" />
                    <text
                    id="tblTagAttributeTitle-9"
                    y="108.10444"
                    x="10.947285"
                    style="font-style:normal;font-weight:normal;font-size:9.04874992px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.22621875"
                    xml:space="preserve"><tspan
                        style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.31787515px;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;writing-mode:lr-tb;text-anchor:start;stroke-width:0.22621875"
                        y="108.10444"
                        x="10.947285"
                        id="tspan827-5-7">ADL Interface</tspan></text>
                    <text
                    id="tblTagAttributeType-8"
                    y="141.4426"
                    x="10.850011"
                    style="font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;font-size:3.31787515px;line-height:1.25;font-family:sans-serif;-inkscape-font-specification:'sans-serif, Normal';font-variant-ligatures:normal;font-variant-caps:normal;font-variant-numeric:normal;font-feature-settings:normal;text-align:start;letter-spacing:0px;word-spacing:0px;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.22621875"
                    xml:space="preserve"><tspan
                        style="stroke-width:0.22621875"
                        y="141.4426"
                        x="10.850011"
                        id="tspan831-88-2">DataExchange</tspan></text>
                    <path
                    id="path1028"
                    d="M 210.81761,111.67361 H 35.510799"
                    style="fill:none;stroke:#000000;stroke-width:0.22544862px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(-0.855,0,0,-0.855,510.53686,383.91426)"
                    id="ZeroOrOne-5-0-9">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0-3"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4-6" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6-0" />
                    </g>
                    <path
                    id="path1028-6"
                    d="M 213.31016,198.35936 H 35.741181"
                    style="fill:none;stroke:#000000;stroke-width:0.22689858px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(-0.855,0,0,-0.855,428.47738,314.02821)"
                    id="ZeroOrMore-8-8-4-0">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-6-7-2"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-0-6-3" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-4-8-7" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-8-9-5" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,429.0914,335.84215)"
                    id="ZeroOrMore-8-8-4-0-7">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-6-7-2-3"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-0-6-3-6" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-4-8-7-1" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-8-9-5-2" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,429.0914,358.94878)"
                    id="ZeroOrMore-8-8-4-0-1">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-6-7-2-9"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-0-6-3-4" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-4-8-7-7" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-8-9-5-8" />
                    </g>
                    <path
                    id="path1137"
                    d="m 107.97978,153.85185 h 24.0788"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1139"
                    d="m 108.05424,149.7577 h 15.54926 v -17.70844 h 7.94091"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1141"
                    d="m 107.97981,157.72269 h 15.68082 v 19.1156 h 8.5122"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1143"
                    d="M 55.897452,153.66125 H 35.453671"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1145"
                    d="M 55.971872,149.49267 H 35.453671"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1147"
                    d="M 55.971872,157.75541 H 35.339413"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1149"
                    d="M 55.277386,127.7646 H 35.396542"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1151"
                    d="M 55.277386,131.42084 H 35.625058"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1153"
                    d="M 55.391643,134.5058 H 35.396542"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1155"
                    d="M 55.163128,174.21036 H 35.739315"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1157"
                    d="M 55.106,178.03799 H 35.510799"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0,0.855,-0.855,0,260.82268,-188.4858)"
                    id="ZeroOrMore-8-3-3">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,-106.70415,417.95603)"
                    id="ZeroOrOne-5-8-3-1">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-3-3-2"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-8-3-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-3-7-3" />
                    </g>
                    <path
                    id="path1240"
                    d="m 78.769241,108.58683 v 12.07734"
                    style="fill:none;stroke:#000000;stroke-width:0.21435814px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0,0.855,-0.855,0,406.9821,-175.35884)"
                    id="ZeroOrOne-5-8-3-5">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-3-3-9"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-8-3-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-3-7-4" />
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-100.51404,-50.49797)"
                    id="ZeroOrMore-8-3-3-0">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,36.555635,484.79333)"
                    id="ZeroOrOne-5-8-3-5-1">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-3-3-9-7"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-8-3-8-5" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-3-7-4-9" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,52.241577,441.1974)"
                    id="ZeroOrMore-8-3-3-0-6">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4-2"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4-1" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4-7" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4-8" />
                    </g>
                    <g
                    transform="matrix(0,0.855,-0.855,0,370.38495,-134.96397)"
                    id="ZeroOrMore-8-3-3-0-3">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4-1"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4-6" />
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-100.04696,-5.0272492)"
                    id="ZeroOrMore-8-3-3-0-33">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4-8"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4-6" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4-0" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4-4" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,49.699738,484.82344)"
                    id="ZeroOrOne-5-8-3-5-1-3">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-3-3-9-7-0"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-8-3-8-5-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-3-7-4-9-2" />
                    </g>
                    <g
                    transform="matrix(0,0.855,-0.855,0,417.28648,-133.07086)"
                    id="ZeroOrMore-8-3-3-0-6-5">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4-2-4"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4-1-0" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4-7-5" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4-8-9" />
                    </g>
                    <g
                    transform="matrix(0,0.855,-0.855,0,419.80048,-175.47497)"
                    id="ZeroOrOne-5-8-3-5-8">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-3-3-9-1"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-8-3-8-2" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-3-7-4-8" />
                    </g>
                    <path
                    id="path1424"
                    d="m 235.23331,163.8129 v 23.76561"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1426"
                    d="m 234.26211,121.59468 v 22.50877"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1428"
                    d="M 222.03653,187.52139 V 176.89541 H 197.01409"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1430"
                    d="m 221.40812,121.82319 v 9.94042 h -24.85106"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0,0.855,-0.855,0,424.51059,-216.23372)"
                    id="OneOnlyOne-2-6-7-6-2">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-58-1" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-79-0" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-6-5" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,51.939548,399.0034)"
                    id="ZeroOrMore-8-3-3-0-6-1">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4-2-1"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4-1-08" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4-7-50" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4-8-6" />
                    </g>
                    <path
                    id="path1483"
                    d="M 233.91934,101.94235 V 80.4619"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0.855,0,0,0.855,-38.431602,-77.248742)"
                    id="OneOnlyOne-2-6-7-4-4">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-8-6" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-70-2" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-8-5" />
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,-35.555374,9.2960862)"
                    id="OneOnlyOne-2-6-7-4-8">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-8-62" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-70-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-8-4" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,574.55591,295.31378)"
                    id="ZeroOrMore-8-8-4-0-72">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-6-7-2-4"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-0-6-3-0" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-4-8-7-6" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-8-9-5-29" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,574.08968,381.90275)"
                    id="ZeroOrMore-8-8-4-0-9">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-6-7-2-0"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-0-6-3-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-4-8-7-13" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-8-9-5-1" />
                    </g>
                    <path
                    id="path1562"
                    d="m 258.18538,113.36032 h 19.38204"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1564"
                    d="m 261.0616,199.90515 h 16.06145"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(-0.855,0,0,-0.855,646.33999,345.38399)"
                    id="OneOnlyOne-2-6-7-4-8-1">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-8-62-0" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-70-8-3" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-8-4-4" />
                    </g>
                    <g
                    transform="matrix(0.855,0,0,0.855,45.202541,-27.27836)"
                    id="ZeroOrMore-8-3-3-0-3-0">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4-1-3"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4-8-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4-9-1" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4-6-9" />
                    </g>
                    <path
                    id="path1617"
                    d="m 342.19439,154.77507 h 7.39945"
                    style="fill:none;stroke:#000000;stroke-width:0.21748883px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0,0.855,-0.855,0,521.43505,-134.51428)"
                    id="OneOnlyOne-2-6-7-4-8-1-6">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-8-62-0-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-70-8-3-3" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-8-4-4-3" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,140.02258,441.0421)"
                    id="OneOnlyOne-2-6-7-4-8-1-6-8">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-8-62-0-9-0" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-70-8-3-3-5" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-8-4-4-3-6" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,148.72422,484.30054)"
                    id="ZeroOrMore-8-3-3-0-6-6">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4-2-40"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4-1-04" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4-7-6" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4-8-2" />
                    </g>
                    <g
                    transform="matrix(0,0.855,-0.855,0,512.68495,-175.75292)"
                    id="ZeroOrMore-8-3-3-0-6-5-6">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4-2-4-7"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4-1-0-5" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4-7-5-6" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4-8-9-9" />
                    </g>
                    <path
                    id="path1721"
                    d="m 330.63166,144.42512 v -23.19541 h 0.0162"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1723"
                    d="M 330.77763,187.38949 V 162.19146"
                    style="fill:none;stroke:#000000;stroke-width:0.22096749px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0,0.855,-0.855,0,477.72635,-134.3527)"
                    id="OneOnlyOne-2-6-7-4-8-1-6-87">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-8-62-0-9-2" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-70-8-3-3-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-8-4-4-3-2" />
                    </g>
                    <path
                    id="path1751"
                    d="m 188.33201,161.94898 v 3.2723 h 98.80946 v -2.90871"
                    style="fill:none;stroke:#000000;stroke-width:0.22594886px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0,0.855,-0.855,0,429.23261,-175.55941)"
                    id="OneOrMore-6">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.03181,210.34962 -1.4864,0.98503"
                        id="path1254-3-0" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.68603,210.34962 h -2.18675"
                        id="path1258-3-2" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.03181,210.34962 -1.51831,-1.02925"
                        id="path1260-3-7" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.74643,209.27786 v 2.14753 h -0.0285"
                        id="path1286-6" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,575.18728,327.58779)"
                    id="OneOnlyOne-2-6-7-4-8-1-6-87-1">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-8-62-0-9-2-3" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-70-8-3-3-8-2" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-8-4-4-3-2-1" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,575.24441,322.33192)"
                    id="OneOnlyOne-2-6-7-4-8-1-6-87-1-5">
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.1580255px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.92044,222.93459 h -2.18675"
                        id="path1258-3-9-1-43-4-8-62-0-9-2-3-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.98084,221.86283 v 2.14753 h -0.0284"
                        id="path1286-7-7-3-4-70-8-3-3-8-2-9" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.19446,221.83095 v 2.14753 h -0.0285"
                        id="path1286-7-6-8-3-3-8-4-4-3-2-1-1" />
                    </g>
                    <path
                    id="path1828"
                    d="m 249.38368,120.85714 v 10.62083 h 29.21043"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <path
                    id="path1830"
                    d="m 251.06775,188.47171 v -11.1764 h 21.69922 v -40.27584 h 5.48436"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0.855,0,0,0.855,18.086928,-51.603866)"
                    id="ZeroOrOne-5-0-9-4">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0-3-9"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4-6-1" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6-0-0" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,141.40334,440.36469)"
                    id="ZeroOrMore-8-3-3-0-6-6-7">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4-2-40-5"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4-1-04-8" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4-7-6-7" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4-8-2-0" />
                    </g>
                    <path
                    id="path1883"
                    d="m 315.15657,133.87738 h 8.28368 v 9.42626"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(0,0.855,-0.855,0,408.69155,-89.45663)"
                    id="ZeroOrMore-8-8-4-5">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-6-7-29"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-0-6-0" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-4-8-2" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-8-9-8" />
                    </g>
                    <path
                    id="path2934"
                    d="m 213.26924,201.9156 h -6.16991 v 17.19579 h 19.70945 v -11.65428"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                    <g
                    transform="matrix(-0.855,0,0,-0.855,510.53243,387.52654)"
                    id="ZeroOrOne-5-0-28-8-3-3">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0-2-8-3-8"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4-9-8-8-0" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6-9-6-0-4" />
                    </g>
                    <g
                    transform="matrix(-0.855,0,0,-0.855,507.82523,292.96284)"
                    id="ZeroOrOne-5-0-28-8-3-0">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-6-5-0-2-8-3-9"
                        cx="346.78891"
                        cy="217.00433"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 346.04604,217.02327 h -1.53253"
                        id="path1258-4-4-4-9-8-8-1" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.53756,215.89711 v 2.14754 h -0.0285"
                        id="path1286-8-7-6-9-6-0-9" />
                    </g>
                    <g
                    transform="matrix(0,-0.855,0.855,0,38.773326,398.88689)"
                    id="ZeroOrMore-8-3-3-0-6-62">
                    <ellipse
                        style="opacity:1;fill:none;fill-opacity:1;stroke:#000009;stroke-width:0.15983413;stroke-linejoin:round;stroke-miterlimit:2.5;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1"
                        id="path1250-3-2-6-4-2-5"
                        cx="346.58984"
                        cy="212.90901"
                        rx="0.71110511"
                        ry="0.74721688" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.14472967px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.4864,0.98504"
                        id="path1254-1-6-5-4-1-4" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 h -1.53253"
                        id="path1258-8-5-6-4-7-4" />
                    <path
                        style="fill:none;stroke:#000000;stroke-width:0.13229166px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                        d="m 345.84698,212.928 -1.51831,-1.02924"
                        id="path1260-9-2-3-4-8-99" />
                    </g>
                    <path
                    id="path2975"
                    d="m 210.58419,107.36733 h -8.1123 V 92.171058 h 18.10985 v 9.654782"
                    style="fill:none;stroke:#000000;stroke-width:0.22621875px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
                </g>
                </svg>
            </div>
        </div>

        <div id="Team" class="mugshots">
            <div class="col-2 col-s-2 card-4">
                <div class="rounded">
                    <header class="card-header">
                        <h3>Sandy Thom</h3>
                    </header>
                    <div class="vcard">
                        <p class="title">Technical Director</p>
                        <hr>
                        <img src="images/TELE9999999997_Sandy_Thom.jpg" alt="Sandy Avatar" width="160px" height="100px">
                        <p class="bio">Background in Subsea Controls</p>
                        <br />
                    </div>
                    <button class="c4-button"><a href="mailto:sandy@trojanenergyltd.com" style="text-decoration:none;">+ More</a></button>
                </div>
            </div>
            <div class="col-2 col-s-2 card-4">
                <div class="rounded">
                    <header class="card-header">
                        <h3>Tom Dalziel</h3>
                    </header>
                    <div class="vcard">
                        <p class="title">Cloud Architect</p>
                        <hr>
                        <img src="images/TELE0000000001_Tom_Dalziel.png" alt="Tom Avatar" width="100px" height="100px">
                        <p class="bio">Background in Artificial Intelligence</p>
                        <br />
                    </div>
                    <button class="c4-button"><a href="mailto:tom.dalziel@trojan.energy" style="text-decoration:none;">+ More</a></button>
                </div>
            </div>
            <div class="col-2 col-s-2 card-4">
                <div class="rounded">
                    <header class="card-header">
                        <h3>Carol Wilson</h3>
                    </header>
                    <div class="vcard">
                        <p class="title">Lead Data Engineer</p>
                        <hr>
                        <img src="images/TELE0000000004_Carol_Wilson.jpg" alt="Carol Avatar" width="160px" height="100px">
                        <p class="bio">Background in Mathematics / Computing Science</p>
                    </div>
                    <button class="c4-button"><a href="mailto:carol@trojanenergyltd.com" style="text-decoration:none;">+ More</a></button>
                </div>
            </div>
            <div class="col-2 col-s-2 card-4">
                <div class="rounded">
                    <header class="card-header">
                        <h3>Allan Murray</h3>
                    </header>
                    <div class="vcard">
                        <p class="title">Systems Engineer</p>
                        <hr>
                        <img src="images/TELE0000000007_Allan_Murray.jpg" alt="Allan Avatar" width="100px" height="100px">
                        <p class="bio">Background in Systems / Telecommunications Engineering</p>
                    </div>
                    <button class="c4-button"><a href="mailto:allan@trojanenergyltd.com" style="text-decoration:none;">+ More</a></button>
                </div>
            </div>
            <div class="col-2 col-s-2 card-4">
                <div class="rounded">
                    <header class="card-header">
                        <h3>Mark McCormick</h3>
                    </header>
                    <div class="vcard">
                        <p class="title">Principal Hardware Engineer</p>
                        <hr>
                        <img src="images/TELE0000000017_Mark_McCormick.jpg" alt="Mark Avatar" width="75px" height="100px">
                        <p class="bio">Background in High Reliability Electronics / </p>
                    </div>
                    <button class="c4-button"><a href="mailto:mark.mccormick@trojanenergyltd.com" style="text-decoration:none;">+ More</a></button>
                </div>
            </div>
            <div class="col-2 col-s-2 card-4">
                <div class="rounded">
                    <header class="card-header">
                        <h3>Christopher Dalziel</h3>
                    </header>
                    <div class="vcard">
                        <p class="title">Intern - Software Engineering</p>
                        <hr>
                        <img src="images/avatar3.png" alt="Chris Avatar" width="100px" height="100px">
                        <p class="bio">Studying Computer Science</p>
                        <br />
                    </div>
                    <button class="c4-button"><a href="mailto:chris@trojanenergyltd.com" style="text-decoration:none;">+ More</a></button>
                </div>
            </div>
            <div class="col-2 col-s-2 card-4">
                <div class="rounded">
                    <header class="card-header">
                        <h3>Max McGill</h3>
                    </header>
                    <div class="vcard">
                        <p class="title">Intern - Software Engineering</p>
                        <hr>
                        <img src="images/avatar1.png" alt="Max Avatar" width="100px" height="100px">
                        <p class="bio">Intends Studying Computer Science</p>
                        <br />
                    </div>
                    <button class="c4-button"><a href="mailto:max@trojanenergyltd.com" style="text-decoration:none;">+ More</a></button>
                </div>
            </div>
            <div class="col-2 col-s-2 card-4">
                <div class="rounded">
                    <header class="card-header">
                        <h3>Logan Thom</h3>
                    </header>
                    <div class="vcard">
                        <p class="title">Intern - Electronics Engineering</p>
                        <hr>
                        <img src="images/avatar3.png" alt="Logan Avatar" width="100px" height="100px">
                        <p class="bio">Intends Studying Electronics Engineering</p>
                    </div>
                    <button class="c4-button"><a href="mailto:logan@trojanenergyltd.com" style="text-decoration:none;">+ More</a></button>
                </div>
            </div>
        </div>

        <div class="footer">
            <h4>TROJAN ENERGY LIMITED, 2022</h4>
            <p>Powered by Naked CSS</p>
        </div>

        <!-- ------------------------------------------------------------------------------------------------------------------------------------- -->



    <script type="text/javascript">

            function verify_pop(p, g, b, m, n) {
                if (g + b + m + n == p) return 0;
                else return 1;
            }

            //function display_progress(tid, p, g, b, m, n) {
            function display_progress() {
                var g_clr = "rgb(0,198,0)";
                var b_clr = "rgb(198,0,0)";
                var m_clr = "rgb(198,165,0)";
                var n_clr = "rgb(198,198,198)";

                p = 321;
                g = 198;
                m = 57;
                b = 32;
                n = 34;

                if(verify_pop(p,g,b,m,n)) {return 0};

                var g_norm = Math.round((g/p) * 100);
                var b_norm = Math.round((b/p) * 100);
                var m_norm = Math.round((m/p) * 100);
                var n_norm = Math.round((n/p) * 100);

                Array.from(document.getElementById("datasheets_grid").getElementsByClassName("ProgUnit")).forEach(
                    function(element, index, array) {
                        if (index < g_norm) {
                            attributeText = "fill:" + g_clr + ";stroke-width:1;stroke:" + g_clr;
                        }
                        else if (index < m_norm + g_norm) {
                            attributeText = "fill:" + m_clr + ";stroke-width:1;stroke:" + m_clr;
                        }
                        else if (index < b_norm + m_norm + g_norm) {
                            attributeText = "fill:" + b_clr + ";stroke-width:1;stroke:" + b_clr;
                        }
                        else {
                            attributeText = "fill:" + n_clr + ";stroke-width:1;stroke:" + n_clr;
                        }
                        element.setAttribute("style", attributeText);
                    }
                );

                var element1 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element1.setAttributeNS(null, 'x', 0);
                element1.setAttributeNS(null, 'y', 8);
                element1.setAttributeNS(null, 'style', "font-size:x-small;");
                var txt1 = document.createTextNode("Datasheets");
                element1.appendChild(txt1);
                var svgchart = document.getElementById("datasheets_grid");
                var chartarea = svgchart.children[2];
                var chart_title_field = chartarea.children[0];
                chartarea.insertBefore(element1, chart_title_field);
                chartarea.removeChild(chart_title_field);

                var element2 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element2.setAttributeNS(null, 'x', 20);
                element2.setAttributeNS(null, 'y', 128);
                element2.setAttributeNS(null, 'style', "font-size:xx-small;");
                var txt2 = document.createTextNode("Datasheets Identified");
                element2.appendChild(txt2);
                var good_text = chartarea.children[105];
                chartarea.insertBefore(element2, good_text);
                chartarea.removeChild(good_text);

                var element3 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element3.setAttributeNS(null, 'x', 20);
                element3.setAttributeNS(null, 'y', 138);
                element3.setAttributeNS(null, 'style', "font-size:xx-small;");
                var txt3 = document.createTextNode("Datasheets Similar");
                element3.appendChild(txt3);
                var meh_text = chartarea.children[106];
                chartarea.insertBefore(element3, meh_text);
                chartarea.removeChild(meh_text);

                var element4 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element4.setAttributeNS(null, 'x', 20);
                element4.setAttributeNS(null, 'y', 148);
                element4.setAttributeNS(null, 'style', "font-size:xx-small;");
                var txt4 = document.createTextNode("No Datasheets Found");
                element4.appendChild(txt4);
                var bad_text = chartarea.children[107];
                chartarea.insertBefore(element4, bad_text);
                chartarea.removeChild(bad_text);

                var element5 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element5.setAttributeNS(null, 'x', 20);
                element5.setAttributeNS(null, 'y', 158);
                element5.setAttributeNS(null, 'style', "font-size:xx-small;");
                var txt5 = document.createTextNode("Datasheet Not Required");
                element5.appendChild(txt5);
                var none_text = chartarea.children[108];
                chartarea.insertBefore(element5, none_text);
                chartarea.removeChild(none_text);

                Array.from(document.getElementById("part_numbers_grid").getElementsByClassName("ProgUnit")).forEach(
                    function(element, index, array) {
                        if (index < g_norm) {
                            attributeText = "fill:" + g_clr + ";stroke-width:1;stroke:" + g_clr;
                        }
                        else if (index < m_norm + g_norm) {
                            attributeText = "fill:" + m_clr + ";stroke-width:1;stroke:" + m_clr;
                        }
                        else if (index < b_norm + m_norm + g_norm) {
                            attributeText = "fill:" + b_clr + ";stroke-width:1;stroke:" + b_clr;
                        }
                        else {
                            attributeText = "fill:" + n_clr + ";stroke-width:1;stroke:" + n_clr;
                        }
                        element.setAttribute("style", attributeText);
                    }
                );

                element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element.setAttributeNS(null, 'x', 0);
                element.setAttributeNS(null, 'y', 8);
                element.setAttributeNS(null, 'style', "font-size:x-small;");
                txt = document.createTextNode("Part Numbers");
                element.appendChild(txt);
                svgchart = document.getElementById("part_numbers_grid");
                chartarea = svgchart.children[2];
                chart_title_field = chartarea.children[0];
                chartarea.insertBefore(element, chart_title_field);
                chartarea.removeChild(chart_title_field);

                element2 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element2.setAttributeNS(null, 'x', 20);
                element2.setAttributeNS(null, 'y', 128);
                element2.setAttributeNS(null, 'style', "font-size:xx-small;");
                txt2 = document.createTextNode("Part Numbers Identified");
                element2.appendChild(txt2);
                good_text = chartarea.children[105];
                chartarea.insertBefore(element2, good_text);
                chartarea.removeChild(good_text);

                element3 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element3.setAttributeNS(null, 'x', 20);
                element3.setAttributeNS(null, 'y', 138);
                element3.setAttributeNS(null, 'style', "font-size:xx-small;");
                txt3 = document.createTextNode("Compatible Part Numbers");
                element3.appendChild(txt3);
                meh_text = chartarea.children[106];
                chartarea.insertBefore(element3, meh_text);
                chartarea.removeChild(meh_text);

                element4 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element4.setAttributeNS(null, 'x', 20);
                element4.setAttributeNS(null, 'y', 148);
                element4.setAttributeNS(null, 'style', "font-size:xx-small;");
                txt4 = document.createTextNode("Incompatible Equivalents");
                element4.appendChild(txt4);
                bad_text = chartarea.children[107];
                chartarea.insertBefore(element4, bad_text);
                chartarea.removeChild(bad_text);

                element5 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element5.setAttributeNS(null, 'x', 20);
                element5.setAttributeNS(null, 'y', 158);
                element5.setAttributeNS(null, 'style', "font-size:xx-small;");
                txt5 = document.createTextNode("Part Numbers Not Identified");
                element5.appendChild(txt5);
                none_text = chartarea.children[108];
                chartarea.insertBefore(element5, none_text);
                chartarea.removeChild(none_text);

                Array.from(document.getElementById("manufacturers_grid").getElementsByClassName("ProgUnit")).forEach(
                    function(element, index, array) {
                        if (index < g_norm) {
                            attributeText = "fill:" + g_clr + ";stroke-width:1;stroke:" + g_clr;
                        }
                        else if (index < m_norm + g_norm) {
                            attributeText = "fill:" + m_clr + ";stroke-width:1;stroke:" + m_clr;
                        }
                        else if (index < b_norm + m_norm + g_norm) {
                            attributeText = "fill:" + b_clr + ";stroke-width:1;stroke:" + b_clr;
                        }
                        else {
                            attributeText = "fill:" + n_clr + ";stroke-width:1;stroke:" + n_clr;
                        }
                        element.setAttribute("style", attributeText);
                    }
                );

                element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element.setAttributeNS(null, 'x', 0);
                element.setAttributeNS(null, 'y', 8);
                element.setAttributeNS(null, 'style', "font-size:x-small;");
                txt = document.createTextNode("Manufacturers");
                element.appendChild(txt);
                svgchart = document.getElementById("manufacturers_grid");
                chartarea = svgchart.children[2];
                chart_title_field = chartarea.children[0];
                chartarea.insertBefore(element, chart_title_field);
                chartarea.removeChild(chart_title_field);

                element2 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element2.setAttributeNS(null, 'x', 20);
                element2.setAttributeNS(null, 'y', 128);
                element2.setAttributeNS(null, 'style', "font-size:xx-small;");
                txt2 = document.createTextNode("Manufacturers Identified");
                element2.appendChild(txt2);
                good_text = chartarea.children[105];
                chartarea.insertBefore(element2, good_text);
                chartarea.removeChild(good_text);

                element3 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element3.setAttributeNS(null, 'x', 20);
                element3.setAttributeNS(null, 'y', 138);
                element3.setAttributeNS(null, 'style', "font-size:xx-small;");
                txt3 = document.createTextNode("Manufacturer Similar");
                element3.appendChild(txt3);
                meh_text = chartarea.children[106];
                chartarea.insertBefore(element3, meh_text);
                chartarea.removeChild(meh_text);

                element4 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element4.setAttributeNS(null, 'x', 20);
                element4.setAttributeNS(null, 'y', 148);
                element4.setAttributeNS(null, 'style', "font-size:xx-small;");
                txt4 = document.createTextNode("Manufacturer Not Identified");
                element4.appendChild(txt4);
                bad_text = chartarea.children[107];
                chartarea.insertBefore(element4, bad_text);
                chartarea.removeChild(bad_text);

                element5 = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element5.setAttributeNS(null, 'x', 20);
                element5.setAttributeNS(null, 'y', 158);
                element5.setAttributeNS(null, 'style', "font-size:xx-small;");
                txt5 = document.createTextNode("Legacy Manufacturer");
                element5.appendChild(txt5);
                none_text = chartarea.children[108];
                chartarea.insertBefore(element5, none_text);
                chartarea.removeChild(none_text);

                Array.from(document.getElementById("reach_compliance_grid").getElementsByClassName("ProgUnit")).forEach(
                    function(element, index, array) {
                        if (index < g_norm) {
                            attributeText = "fill:" + g_clr + ";stroke-width:1;stroke:" + g_clr;
                        }
                        else if (index < m_norm + g_norm) {
                            attributeText = "fill:" + m_clr + ";stroke-width:1;stroke:" + m_clr;
                        }
                        else if (index < b_norm + m_norm + g_norm) {
                            attributeText = "fill:" + b_clr + ";stroke-width:1;stroke:" + b_clr;
                        }
                        else {
                            attributeText = "fill:" + n_clr + ";stroke-width:1;stroke:" + n_clr;
                        }
                        element.setAttribute("style", attributeText);
                    }
                );

                element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element.setAttributeNS(null, 'x', 0);
                element.setAttributeNS(null, 'y', 8);
                element.setAttributeNS(null, 'style', "font-size:x-small;");
                txt = document.createTextNode("REACH Compliance");
                element.appendChild(txt);
                svgchart = document.getElementById("reach_compliance_grid");
                chartarea = svgchart.children[2];
                chart_title_field = chartarea.children[0];
                chartarea.insertBefore(element, chart_title_field);
                chartarea.removeChild(chart_title_field);

                Array.from(document.getElementById("rohs_compliance_grid").getElementsByClassName("ProgUnit")).forEach(
                    function(element, index, array) {
                        if (index < g_norm) {
                            attributeText = "fill:" + g_clr + ";stroke-width:1;stroke:" + g_clr;
                        }
                        else if (index < m_norm + g_norm) {
                            attributeText = "fill:" + m_clr + ";stroke-width:1;stroke:" + m_clr;
                        }
                        else if (index < b_norm + m_norm + g_norm) {
                            attributeText = "fill:" + b_clr + ";stroke-width:1;stroke:" + b_clr;
                        }
                        else {
                            attributeText = "fill:" + n_clr + ";stroke-width:1;stroke:" + n_clr;
                        }
                        element.setAttribute("style", attributeText);
                    }
                );

                element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element.setAttributeNS(null, 'x', 0);
                element.setAttributeNS(null, 'y', 8);
                element.setAttributeNS(null, 'style', "font-size:x-small;");
                txt = document.createTextNode("RoHS Compliance");
                element.appendChild(txt);
                svgchart = document.getElementById("rohs_compliance_grid");
                chartarea = svgchart.children[2];
                chart_title_field = chartarea.children[0];
                chartarea.insertBefore(element, chart_title_field);
                chartarea.removeChild(chart_title_field);

                Array.from(document.getElementById("stock_availability_grid").getElementsByClassName("ProgUnit")).forEach(
                    function(element, index, array) {
                        if (index < g_norm) {
                            attributeText = "fill:" + g_clr + ";stroke-width:1;stroke:" + g_clr;
                        }
                        else if (index < m_norm + g_norm) {
                            attributeText = "fill:" + m_clr + ";stroke-width:1;stroke:" + m_clr;
                        }
                        else if (index < b_norm + m_norm + g_norm) {
                            attributeText = "fill:" + b_clr + ";stroke-width:1;stroke:" + b_clr;
                        }
                        else {
                            attributeText = "fill:" + n_clr + ";stroke-width:1;stroke:" + n_clr;
                        }
                        element.setAttribute("style", attributeText);
                    }
                );

                element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element.setAttributeNS(null, 'x', 0);
                element.setAttributeNS(null, 'y', 8);
                element.setAttributeNS(null, 'style', "font-size:x-small;");
                txt = document.createTextNode("Stock Availability");
                element.appendChild(txt);
                svgchart = document.getElementById("stock_availability_grid");
                chartarea = svgchart.children[2];
                chart_title_field = chartarea.children[0];
                chartarea.insertBefore(element, chart_title_field);
                chartarea.removeChild(chart_title_field);

                Array.from(document.getElementById("vendor_availability_grid").getElementsByClassName("ProgUnit")).forEach(
                    function(element, index, array) {
                        if (index < g_norm) {
                            attributeText = "fill:" + g_clr + ";stroke-width:1;stroke:" + g_clr;
                        }
                        else if (index < m_norm + g_norm) {
                            attributeText = "fill:" + m_clr + ";stroke-width:1;stroke:" + m_clr;
                        }
                        else if (index < b_norm + m_norm + g_norm) {
                            attributeText = "fill:" + b_clr + ";stroke-width:1;stroke:" + b_clr;
                        }
                        else {
                            attributeText = "fill:" + n_clr + ";stroke-width:1;stroke:" + n_clr;
                        }
                        element.setAttribute("style", attributeText);
                    }
                );

                element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element.setAttributeNS(null, 'x', 0);
                element.setAttributeNS(null, 'y', 8);
                element.setAttributeNS(null, 'style', "font-size:x-small;");
                txt = document.createTextNode("Vendor Availability");
                element.appendChild(txt);
                svgchart = document.getElementById("vendor_availability_grid");
                chartarea = svgchart.children[2];
                chart_title_field = chartarea.children[0];
                chartarea.insertBefore(element, chart_title_field);
                chartarea.removeChild(chart_title_field);

                Array.from(document.getElementById("delivery_grid").getElementsByClassName("ProgUnit")).forEach(
                    function(element, index, array) {
                        if (index < g_norm) {
                            attributeText = "fill:" + g_clr + ";stroke-width:1;stroke:" + g_clr;
                        }
                        else if (index < m_norm + g_norm) {
                            attributeText = "fill:" + m_clr + ";stroke-width:1;stroke:" + m_clr;
                        }
                        else if (index < b_norm + m_norm + g_norm) {
                            attributeText = "fill:" + b_clr + ";stroke-width:1;stroke:" + b_clr;
                        }
                        else {
                            attributeText = "fill:" + n_clr + ";stroke-width:1;stroke:" + n_clr;
                        }
                        element.setAttribute("style", attributeText);
                    }
                );

                element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                element.setAttributeNS(null, 'x', 0);
                element.setAttributeNS(null, 'y', 8);
                element.setAttributeNS(null, 'style', "font-size:x-small;");
                txt = document.createTextNode("Delivery Schedule");
                element.appendChild(txt);
                svgchart = document.getElementById("delivery_grid");
                chartarea = svgchart.children[2];
                chart_title_field = chartarea.children[0];
                chartarea.insertBefore(element, chart_title_field);
                chartarea.removeChild(chart_title_field);

                scale_progress(0.75);
            }

            //function scale_progress(tid, f) {
            function scale_progress(f) {
                var target = document.getElementById("datasheets_grid").getElementById("Progress");
                var scaleFactor = "scale(" + f.toString() + ")";
                target.setAttribute("transform", scaleFactor);

                target = document.getElementById("part_numbers_grid").getElementById("Progress");
                scaleFactor = "scale(" + f.toString() + ")";
                target.setAttribute("transform", scaleFactor);

                target = document.getElementById("manufacturers_grid").getElementById("Progress");
                scaleFactor = "scale(" + f.toString() + ")";
                target.setAttribute("transform", scaleFactor);

                target = document.getElementById("reach_compliance_grid").getElementById("Progress");
                scaleFactor = "scale(" + f.toString() + ")";
                target.setAttribute("transform", scaleFactor);

                target = document.getElementById("rohs_compliance_grid").getElementById("Progress");
                scaleFactor = "scale(" + f.toString() + ")";
                target.setAttribute("transform", scaleFactor);

                target = document.getElementById("stock_availability_grid").getElementById("Progress");
                scaleFactor = "scale(" + f.toString() + ")";
                target.setAttribute("transform", scaleFactor);

                target = document.getElementById("vendor_availability_grid").getElementById("Progress");
                scaleFactor = "scale(" + f.toString() + ")";
                target.setAttribute("transform", scaleFactor);

                target = document.getElementById("delivery_grid").getElementById("Progress");
                scaleFactor = "scale(" + f.toString() + ")";
                target.setAttribute("transform", scaleFactor);
            }

            // -------------------------------------------------
            // Global Variable : Modal Dialogue Handle
            // -------------------------------------------------
            var modal;

            // -------------------------------------------------
            // GET : DOC Modal Button
            // -------------------------------------------------
            var docbtn = document.getElementById("docButton");
            // -------------------------------------------------
            // Display Modal on CLICK EVENT
            // -------------------------------------------------
            docbtn.addEventListener("click", function(){
                var identifier = docButton.dataset.myCustomKey;
                modal = document.getElementById(identifier);
                modal.style.display = "block";
                modal.zIndex = 999;
            },
            false);

            // -------------------------------------------------
            // GET : Models Modal Button
            // -------------------------------------------------
            var modbtn = document.getElementById("modButton");
            // -------------------------------------------------
            // Display Modal on CLICK EVENT
            // -------------------------------------------------
            modbtn.addEventListener("click", function(){
                var identifier = modButton.dataset.myCustomKey;
                modal = document.getElementById(identifier);
                modal.style.display = "block";
                model.zIndex = 999;
            },
            false);

            // -------------------------------------------------
            // GET : SPAN Element Closes Modal Dialogues
            // -------------------------------------------------
            var span = document.getElementsByClassName("close");
            // -------------------------------------------------
            // User clicks on <span> (x) : close the modal
            // Iterate over each span element of each modal
            // -------------------------------------------------
            for (var i = 0; i < span.length; i++){
                span[i].onclick = function(){
                    modal.style.display = "none";
                    // -----------------------------------------
                    // Flush Content
                    // -----------------------------------------
                    if(modal.id == "tableSchemaModal") {
                        document.getElementById("tblSchemaModalTitle").innerText = "";
                        const myNode = document.getElementById("tblSchemaModalResults")
                        while(myNode.firstChild) {
                            myNode.removeChild(myNode.lastChild);
                        }
                    }
                }
            }
            // -------------------------------------------------
            // User clicks outside the modal : CLOSE??? TBD
            // -------------------------------------------------
            window.onclick = function(event) {
                if (event.target == modal) {
                    modal.style.display = "none";
                    // -----------------------------------------
                    // Flush Content
                    // -----------------------------------------
                    if(modal.id == "tableSchemaModal") {
                        document.getElementById("tblSchemaModalTitle").innerText = "";
                        const myNode = document.getElementById("tblSchemaModalResults")
                        while(myNode.firstChild) {
                            myNode.removeChild(myNode.lastChild);
                        }
                    }

                }
            }

        </script>

    </body>
</html>`;
